(function ($) {
  var $body = $("body"),
    $doc = $(document),
    $html = $("html"),
    $win = $(window);
  $doc.ready(() => {
    $doc.ajaxStart(() => {
      halo.isAjaxLoading = !0;
    }),
      $doc.ajaxStop(() => {
        halo.isAjaxLoading = !1;
      }),
      halo.ready();
  }),
    (window.onload = function () {
      halo.init();
    });
  var halo = {
    haloTimeout: null,
    isAjaxLoading: !1,
    ready: function () {
      this.loaderScript(),
        this.loaderProductBlock(),
        navigator.userAgent.match(/Mac OS X.*(?:Safari|Chrome)/) &&
        !navigator.userAgent.match(/Chrome/)
          ? document.body.classList.add("safari")
          : document.body.classList.add("chrome"),
        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
          !window.MSStream &&
          document.body.classList.add("iOS"),
        $body.hasClass("template-product") &&
          (this.loaderRecommendationsBlock(), this.scrollToReview()),
        $("[data-product-tab-block]").length && this.clickedActiveProductTabs(),
        $body.hasClass("product-card-layout-07") &&
          this.calculateTranslateYHeight(),
        (window.sharedFunctions = {
          setLocalStorageProductForWishlist:
            this.setLocalStorageProductForWishlist,
          checkNeedToConvertCurrency: this.checkNeedToConvertCurrency,
          productBlockSilder: this.productBlockSilder,
          productBlockScroller: this.productBlockScroller,
          calculateTranslateYHeight: this.calculateTranslateYHeight,
        });
    },
    init: function () {
      this.initMultiTab(),
        this.initMultiTabMobile(),
        this.productBlockInfiniteScroll(),
        this.initGlobalCheckbox(),
        this.initColorSwatch(),
        this.initAddToCart(),
        this.initQuickShop(),
        this.initQuickCart(),
        this.initNotifyInStock(),
        this.initCompareProduct(),
        this.initWishlist(),
        this.initAskAnExpert(),
        this.initHeader(),
        this.headerLanguageCurrency(),
        this.headerMasonry(),
        this.initLiveChat(),
        this.headerSidebarSearch(),
        this.headerStickySearchForm(),
        this.initCountdown(),
        this.collectionCountdown(),
        this.handleScrollDown(),
        this.initVideoPopup(),
        this.swapHoverVideoProductCard(),
        this.initDynamicBrowserTabTitle(),
        this.initWarningPopup(),
        this.clickIconScrollSection(),
        this.specialBanner(),
        this.formMessage(),
        $(".lookbook-carousel").length && this.lookbookCarousel(),
        (window.quick_view.show || window.quick_view.show_mb) &&
          this.initQuickView(),
        window.innerWidth < 1025 &&
          (this.menuSidebarMobile(), this.menuSidebarMobileToggle());
      const loadingImages = document.querySelectorAll(
          ".media--loading-effect img"
        ),
        productGrid = document.getElementById("main-collection-product-grid");
      (loadingImages.length > 0 || productGrid) &&
        this.initLazyloadObserver(loadingImages, productGrid),
        $body.hasClass("show_effect_close") &&
          (this.backgroundOverlayHoverEffect(),
          this.backgroundOverlayHoverEffect1()),
        window.innerWidth > 1024 && this.productMenuSlider(),
        $body.hasClass("template-cart") && this.updateGiftWrapper(),
        ($body.hasClass("template-product") ||
          $(".product-details").hasClass("featured-product")) &&
          (this.initProductView($(".halo-productView")),
          this.initProductBundle(),
          this.articleGallery(),
          this.toggleSidebarMobile(),
          this.initCollapseSidebarBlock(),
          this.initCategoryActive(),
          this.initProductReviewSection(),
          this.productCustomInformation(),
          this.iconZoomClickMobile()),
        ($body.hasClass("template-blog") ||
          $body.hasClass("template-article")) &&
          (this.initCollapseSidebarBlock(),
          this.initCategoryActive(),
          this.toggleSidebarMobile(),
          this.initBlogMasonry(),
          this.productBlockSilderSidebar(),
          this.productBlockSilderArticle()),
        $body.hasClass("template-article") && this.articleGallery(),
        ($body.hasClass("template-collection") ||
          $body.hasClass("template-search")) &&
          (this.initCollapseSidebarBlock(),
          this.initCategoryActive(),
          this.toggleSidebarMobile(),
          this.productBlockSilderSidebar(),
          this.initInfiniteScrolling(),
          this.initQuickShopProductList()),
        $body.hasClass("template-list-collections") &&
          (this.toggleSidebarMobile(), this.productBlockSilderSidebar()),
        $body.hasClass("template-collection") &&
          $(".collection-express-order").length &&
          (this.toggleVariantsForExpressOrder(),
          this.initExpressOrderAddToCart()),
        halo.checkScrollLayoutForRecenlyViewed();
      let checkMenuMobile;
      window.innerWidth > 1024
        ? (checkMenuMobile = !0)
        : (checkMenuMobile = !1),
        $win.on("resize", () => {
          this.headerSidebarSearch(),
            this.specialBanner(),
            this.specialBannerSlider(),
            window.innerWidth > 1024
              ? document.body.classList.remove("menu_open")
              : checkMenuMobile &&
                ((checkMenuMobile = !1),
                this.menuSidebarMobile(),
                this.menuSidebarMobileToggle(),
                this.initMultiTab(),
                this.initMultiTabMobile());
        });
    },
    checkNeedToConvertCurrency: function () {
      return (
        (window.show_multiple_currencies &&
          typeof Currency < "u" &&
          Currency.currentCurrency != shopCurrency) ||
        window.show_auto_currency
      );
    },
    loaderScript: function () {
      var load = function () {
        var script = $("[data-loader-script]");
        script.length > 0 &&
          script.each((index2, element) => {
            var $this = $(element),
              link = $this.data("loader-script"),
              top = element.getBoundingClientRect().top;
            $this.hasClass("is-load") ||
              (top < window.innerHeight + 100 &&
                (halo.buildScript(link),
                $('[data-loader-script="' + link + '"]').addClass("is-load")));
          });
      };
      load(), window.addEventListener("scroll", load);
    },
    buildScript: function (name) {
      var loadScript = document.createElement("script");
      (loadScript.src = name), document.body.appendChild(loadScript);
    },
    buildStyleSheet: function (name, $this) {
      if (name == "") return;
      const loadStyleSheet = document.createElement("link");
      (loadStyleSheet.rel = "stylesheet"),
        (loadStyleSheet.type = "text/css"),
        (loadStyleSheet.href = name),
        $this.parentNode.insertBefore(loadStyleSheet, $this);
    },
    loaderProductBlock: function () {
      var isAjaxLoading = !1;
      $doc.ajaxStart(() => {
        isAjaxLoading = !0;
      }),
        $doc.ajaxStop(() => {
          isAjaxLoading = !1;
        });
      const handler = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const $block = $(entry.target);
            if ($block.hasClass("ajax-loaded")) return;
            var url = $block.data("collection"),
              layout = $block.data("layout"),
              limit = $block.data("limit"),
              image_ratio = $block.data("image-ratio"),
              swipe2 = $block.data("swipe"),
              sectionId = $block.attr("sectionId");
            (hasCountdown = $block.attr("hasCountdown")),
              url != null && url != null
                ? $.ajax({
                    type: "get",
                    url: window.routes.root + "/collections/" + url,
                    cache: !1,
                    data: {
                      view: "ajax_product_block",
                      constraint:
                        "limit=" +
                        limit +
                        "+layout=" +
                        layout +
                        "+sectionId=" +
                        sectionId +
                        "+imageRatio=" +
                        image_ratio +
                        "+swipe=" +
                        swipe2 +
                        "+hasCountdown=" +
                        hasCountdown,
                    },
                    beforeSend: function () {
                      $block.addClass("ajax-loaded");
                    },
                    success: function (data) {
                      if (url != "") {
                        const res = halo.handleResponse($(data), 0, limit);
                        layout == "grid"
                          ? $block.find(".products-grid").html(res)
                          : layout == "slider"
                          ? $block.find(".products-carousel").html(res)
                          : layout == "scroll" &&
                            $block.find(".products-flex").html(res);
                      }
                    },
                    complete: function () {
                      if (
                        (layout == "slider" && halo.productBlockSilder($block),
                        layout == "scroll" &&
                          $block
                            .find("[data-enable-hover]")
                            .attr("data-enable-hover") === "true" &&
                          halo.productBlockScroller($block),
                        $block.hasClass("special-banner__product") &&
                          layout == "grid" &&
                          window.innerWidth < 1200 &&
                          ($block
                            .find(".special-banner__products--grid")
                            .addClass("products-carousel"),
                          halo.productBlockSilder($block)),
                        window.compare.show)
                      ) {
                        var $compareLink = $("[data-compare-link]");
                        halo.setLocalStorageProductForCompare($compareLink);
                      }
                      if (
                        (halo.swapHoverVideoProductCard(),
                        window.wishlist.show &&
                          halo.setLocalStorageProductForWishlist(),
                        halo.checkNeedToConvertCurrency() &&
                          Currency.convertAll(
                            window.shop_currency,
                            $("#currencies .active").attr("data-currency"),
                            "span.money",
                            "money_format"
                          ),
                        window.review.show &&
                          $(".shopify-product-reviews-badge").length > 0 &&
                          window.SPR != null &&
                          typeof window.SPR.registerCallbacks == "functions")
                      )
                        return (
                          window.SPR.registerCallbacks(),
                          window.SPR.initRatingHandler(),
                          window.SPR.initDomEls(),
                          window.SPR.loadProducts(),
                          window.SPR.loadBadges()
                        );
                    },
                  })
                : ($block.addClass("ajax-loaded"),
                  layout == "slider" && halo.productBlockSilder($block),
                  halo.checkNeedToConvertCurrency() &&
                    Currency.convertAll(
                      window.shop_currency,
                      $("#currencies .active").attr("data-currency"),
                      "span.money",
                      "money_format"
                    ));
          }
        });
      };
      this.productBlock = document.querySelectorAll("[data-product-block]");
      const config = { rootMargin: "0px 0px 200px 0px" };
      (this.observer = new IntersectionObserver(handler, config)),
        this.productBlock.forEach((block) => {
          this.observer.observe(block);
        });
    },
    handleResponse($res, productToShow, limit) {
      return ($res = $res.splice(productToShow, limit)), $res;
    },
    loaderRecommendationsBlock: function () {
      halo.buildRecommendationBlock();
    },
    scrollToReview: function () {
      var $scope = $(".productView-tab");
      $scope.length &&
        $doc.on(
          "click",
          ".productView-details .halo-productReview",
          (event2) => {
            event2.preventDefault(),
              $("body,html").animate({ scrollTop: $scope.offset().top }, 1e3);
            var activeTab = $scope.find('[href="#tab-review"]'),
              activeTabCustom = $scope.find('[href="#tab-customer-reviews"]'),
              activeTabMb = $scope.find('[href="#tab-review-mobile"]'),
              activeTabCustomMb = $scope.find(
                '[href="#tab-customer-reviews-mobile"]'
              );
            (!activeTab.hasClass("is-open") ||
              !activeTabMb.hasClass("is-open") ||
              !activeTabCustom.hasClass("is-open") ||
              !activeTabCustomMb.hasClass("is-open")) &&
              (activeTab[0]?.click(),
              activeTabMb[0]?.click(),
              activeTabCustom[0]?.click(),
              activeTabCustomMb[0]?.click());
          }
        );
    },
    headerMasonry: function () {
      $(".menu-dropdown__wrapper [data-masonry]").masonry({
        columnWidth: ".grid-sizer",
        itemSelector: "[data-gridItem]",
      });
    },
    initLiveChat: function () {
      var $item_globe = $(".live-wrapper-icon");
      $item_globe.on("click", function (e) {
        $(this).parent().toggleClass("live_help--active");
      }),
        $body.on("click", function (e) {
          $(".live_help").hasClass("live_help--active") &&
            $(event.target).closest(".live_help").length === 0 &&
            (e.preventDefault(),
            $(".live_help").removeClass("live_help--active"));
        });
    },
    initHeader: function () {
      const headerAll = document.querySelectorAll('[class*="section-header"]');
      if (headerAll) {
        let index2 = headerAll.length + 20;
        headerAll.forEach((element) => {
          element.classList.contains("section-header-mobile") ||
            (element.setAttribute("data-index", index2),
            (element.style.zIndex = index2),
            index2--);
        });
        const headerBasicTransparent = document.querySelector(
          ".header-basic--transparent"
        );
        if (
          headerBasicTransparent &&
          document.body.classList.contains("template-index")
        ) {
          const height = headerBasicTransparent.offsetHeight,
            navTransparent = document.querySelector(
              '.header-navigation[class*="--transparent"]'
            );
          navTransparent &&
            ((navTransparent.style.top = `${height}px`),
            navTransparent.classList.add("has-top"));
        }
      }
    },
    headerLanguageCurrency: function () {
      if (!document.querySelector(".header-language_currency")) return;
      const header = document.querySelectorAll('[class*="section-header-"]');
      document.addEventListener("click", (event2) => {
        const $target = event2.target,
          $headerLanguageCurrency = $target.closest(
            ".header-language_currency"
          ),
          languageCurrency = $headerLanguageCurrency?.querySelector(
            ".top-language-currency"
          ),
          dropdownCurrency =
            $headerLanguageCurrency?.querySelector(".dropdown-currency"),
          dropdownLanguage =
            $headerLanguageCurrency?.querySelector(".dropdown-language");
        $target.matches(".header-language_currency") ||
        $target.closest(".header-language_currency")
          ? (($target.matches(".icon-languageCurrency") ||
              $target.closest(".icon-languageCurrency") ||
              (($target.matches(".top-language-currency") ||
                $target.closest(".top-language-currency")) &&
                !document.querySelector(".icon-languageCurrency"))) &&
              languageCurrency?.classList.toggle("show"),
            ($target.matches(".halo-top-currency") ||
              $target.closest(".halo-top-currency")) &&
              (dropdownLanguage?.classList.remove("show"),
              dropdownCurrency?.classList.toggle("show")),
            ($target.matches(".halo-top-language") ||
              $target.closest(".halo-top-language")) &&
              (dropdownCurrency?.classList.remove("show"),
              dropdownLanguage?.classList.toggle("show")),
            $target.matches(".dropdown-menu .dropdown-item") &&
              (dropdownCurrency?.classList.remove("show"),
              dropdownLanguage?.classList.remove("show")))
          : header.forEach((element) => {
              element
                .querySelector(".top-language-currency")
                ?.classList.remove("show"),
                element
                  .querySelector(".dropdown-currency")
                  ?.classList.remove("show"),
                element
                  .querySelector(".dropdown-language")
                  ?.classList.remove("show");
            });
      });
    },
    headerSidebarSearch: function () {
      var headerSearchPC = $(".header-top .header__search .search_details"),
        headerSearchMB = $(
          "#search-form-mobile .halo-sidebar-wrapper .search_details"
        ),
        headerwraperSearchPC = $(".header-top .header__search"),
        headerwraperSearchMB = $("#search-form-mobile .halo-sidebar-wrapper"),
        searchDetails = $(".search_details"),
        predictiveSearchPC = $(".header-top .header__search predictive-search"),
        predictiveSearchMB = $(
          "#search-form-mobile .halo-sidebar-wrapper predictive-search"
        );
      predictiveSearchPC.length === 0 &&
        (predictiveSearchPC = $(".header-top .header__search .search_details")),
        predictiveSearchMB.length === 0 &&
          (predictiveSearchMB = $(
            "#search-form-mobile .halo-sidebar-wrapper .search_details"
          )),
        window.innerWidth < 1025
          ? ($(".header").hasClass("header-01") &&
              predictiveSearchPC.appendTo(headerwraperSearchMB),
            searchDetails.attr("open", "true"),
            $("[data-search-mobile]").on("click", (event2) => {
              event2.preventDefault(), $("body").addClass("open_search_mobile");
            }),
            $("[data-search-close-sidebar], .background-overlay").on(
              "click",
              (event2) => {
                event2.preventDefault(),
                  $("body").removeClass("open_search_mobile");
              }
            ))
          : ($(".header").hasClass("header-01") &&
              predictiveSearchMB.appendTo(headerwraperSearchPC),
            searchDetails.removeAttr("open"),
            $(".search-modal__close-button").on("click", (event2) => {
              $(".search_details").removeAttr("open"),
                $("body").removeClass("open_search_menu");
            }),
            $("[data-search-menu]").on("click", (event2) => {
              event2.preventDefault(), $("body").addClass("open_search_menu");
            }));
    },
    headerStickySearchForm: function () {
      var iconSearchSlt = "[data-search-sticky-form]",
        iconSearchMenu = "[data-search-menu-sticky-form] .icon-search",
        iconSearchMenuCustom =
          "[data-search-menu-sticky-form] .icon-search-custom";
      $(window).width() > 1025 &&
        ($(document)
          .off("click.toggleSearch", iconSearchSlt)
          .on("click.toggleSearch", iconSearchSlt, function (event2) {
            event2.preventDefault(),
              event2.stopPropagation(),
              $("body").addClass("sticky-search-open"),
              $(".search_details").attr("open", "true");
          }),
        $(document)
          .off("click.hideSearch")
          .on("click.hideSearch", function (event2) {
            var formSearch = $(".search-modal__form"),
              quickSearch = $(".quickSearchResultsWrap");
            $("body").hasClass("sticky-search-open") &&
              !formSearch.has(event2.target).length &&
              !quickSearch.has(event2.target).length &&
              ($("body").removeClass("sticky-search-open"),
              $('[class*="section-header-"]').removeClass(
                "sticky-search-menu-open"
              ),
              $(".search_details").removeAttr("open"));
          }),
        $(document)
          .off("click.toggleSearch", iconSearchMenu)
          .on("click.toggleSearch", iconSearchMenu, function (event2) {
            event2.preventDefault(),
              event2.stopPropagation(),
              $(event2.target)
                .closest('[class*="section-header-"]')
                .addClass("sticky-search-menu-open"),
              $(event2.target)
                .closest(".section-header-navigation")
                .css("z-index", "101"),
              $(".search_details").attr("open", "true");
          }),
        $(document)
          .off("click.toggleSearch", iconSearchMenuCustom)
          .on("click.toggleSearch", iconSearchMenuCustom, function (event2) {
            $(event2.target)
              .closest('[class*="section-header-"]')
              .addClass("sticky-search-menu-custom-open");
          }),
        $(document)
          .off("click.hideSearchSticky")
          .on("click.hideSearchSticky", function (event2) {
            var formSearch = $(".header-navigation .search-modal__form"),
              quickSearch = $(".header-navigation .quickSearchResultsWrap");
            if (
              $('[class*="section-header-"]').hasClass(
                "sticky-search-menu-open"
              ) &&
              !formSearch.has(event2.target).length &&
              !quickSearch.has(event2.target).length
            ) {
              const header = $(iconSearchMenu).closest(
                  ".section-header-navigation"
                ),
                index2 = header.data("index");
              $('[class*="section-header-"]').removeClass(
                "sticky-search-menu-open"
              ),
                header.css("z-index", index2),
                $(".header-navigation .search_details").removeAttr("open"),
                quickSearch.hasClass("is-show") &&
                  quickSearch.removeClass("is-show").addClass("hidden");
            }
            $(event2.target).closest(".search-modal__content").length === 0 &&
              ($("body").removeClass("open_search_menu"),
              $('[class*="section-header-"]').removeClass(
                "sticky-search-menu-custom-open"
              ));
          }));
    },
    menuSidebarMobile: function () {
      var buttonIconOpen = $(".mobileMenu-toggle"),
        buttonClose = $(".halo-sidebar-close, .background-overlay");
      const menuSidebarMobileOpen = () => {
        $body.addClass("menu_open"),
          $(".list-menu-loading").remove(),
          window.mobile_menu == "default" &&
            ($("#navigation-mobile .site-nav-mobile.nav .header__inline-menu")
              .length ||
              $(".header .header__inline-menu").appendTo(
                "#navigation-mobile .site-nav-mobile.nav"
              )),
          $(
            "#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text"
          ).length ||
            $(
              ".header-top--wrapper .header-top--right .free-shipping-text"
            ).appendTo(
              "#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"
            ),
          $(
            "#navigation-mobile .site-nav-mobile.nav-account .customer-service-text"
          ).length ||
            $(
              ".header-top--wrapper .header-top--right .customer-service-text"
            ).appendTo(
              "#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"
            ),
          $("#navigation-mobile .site-nav-mobile.nav-account .header__location")
            .length ||
            $(
              ".header-top--wrapper .header-top--right .header__location"
            ).appendTo(
              "#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"
            ),
          $("#navigation-mobile .top-language-currency").length ||
            ($(".header").hasClass("header-03")
              ? $(
                  ".header .header-bottom-right .top-language-currency"
                ).appendTo(
                  "#navigation-mobile .site-nav-mobile.nav-currency-language"
                )
              : $(".header").hasClass("header-05")
              ? $(".header .header-top--left .top-language-currency").appendTo(
                  "#navigation-mobile .site-nav-mobile.nav-currency-language"
                )
              : $(
                  ".header .header-language_currency .top-language-currency"
                ).appendTo(
                  "#navigation-mobile .site-nav-mobile.nav-currency-language"
                )),
          halo.productMenuSlider();
      };
      document.body.matches(".menu_open") && menuSidebarMobileOpen(),
        buttonIconOpen
          .off("click.toggleCurrencyLanguage")
          .on("click.toggleCurrencyLanguage", (event2) => {
            event2.preventDefault(), menuSidebarMobileOpen();
          }),
        buttonClose
          .off("click.toggleCloseCurrencyLanguage")
          .on("click.toggleCloseCurrencyLanguage", () => {
            $body.removeClass("menu_open"),
              $("#navigation-mobile")
                .off("transitionend.toggleCloseMenu")
                .on("transitionend.toggleCloseMenu", () => {
                  $body.hasClass("menu_open") ||
                    ($(".header .header__inline-menu").length ||
                      ($(".header").hasClass("header-03") ||
                      $(".header").hasClass("header-04") ||
                      $(".header").hasClass("header-07") ||
                      $(".header").hasClass("header-08")
                        ? $(
                            "#navigation-mobile .site-nav-mobile.nav .header__inline-menu"
                          ).appendTo(
                            ".header .header-bottom--wrapper .header-bottom-left"
                          )
                        : $(
                            "#navigation-mobile .site-nav-mobile.nav .header__inline-menu"
                          ).appendTo(".header .header-bottom--wrapper")),
                    $(
                      ".header-top--wrapper .header-top--right .free-shipping-text"
                    ).length ||
                      $(".header-04").hasClass("style_2") ||
                      $(
                        "#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text"
                      ).insertBefore(
                        ".header-top--wrapper .header-top--right .header__group"
                      ),
                    $(
                      ".header-top--wrapper .header-top--right .header__location"
                    ).length ||
                      $(
                        "#navigation-mobile .site-nav-mobile.nav-account .header__location"
                      ).insertBefore(
                        ".header-top--wrapper .header-top--right .header__group"
                      ),
                    $(
                      ".header-top--wrapper .header-top--right .customer-service-text"
                    ).length ||
                      ($(".header").hasClass("header-03")
                        ? $(
                            "#navigation-mobile .site-nav-mobile.nav-account .customer-service-text"
                          ).insertBefore(
                            ".header-top--wrapper .header-top--right .header__group .header__icon--wishlist"
                          )
                        : $(
                            "#navigation-mobile .site-nav-mobile.nav-account .customer-service-text"
                          ).insertBefore(
                            ".header-top--wrapper .header-top--right .top-language-currency"
                          )),
                    $(".header-language_currency .top-language-currency")
                      .length ||
                      ($(".header").hasClass("header-03") ||
                      $(".header").hasClass("header-04")
                        ? $(
                            "#navigation-mobile .site-nav-mobile .top-language-currency"
                          ).appendTo(
                            ".header .header-bottom--wrapper .header-bottom-right .header-language_currency"
                          )
                        : $(".header").hasClass("header-05")
                        ? $(
                            "#navigation-mobile .site-nav-mobile .top-language-currency"
                          ).appendTo(
                            ".header .header-top--wrapper .header-top--left .header-language_currency"
                          )
                        : $(
                            "#navigation-mobile .site-nav-mobile .top-language-currency"
                          ).insertBefore(
                            ".header .header-language_currency .header__search"
                          )));
                });
          }),
        $doc.on("click", ".halo-sidebar-close", function (e) {
          e.preventDefault(),
            e.stopPropagation(),
            $body.removeClass("menu_open");
        });
    },
    menuSidebarMobileToggle: function () {
      $body.on(
        "click",
        ".site-nav-mobile .list-menu .menu_mobile_link",
        function (e) {
          if (!e.currentTarget.classList.contains("list-menu__item--end")) {
            e.preventDefault(), e.stopPropagation();
            var $target = $(this),
              $parent = $target.parent(),
              $menuDislosure1 = $target
                .parent()
                .find("ul.list-menu--disclosure-1");
            $parent
              .removeClass("is-hidden")
              .addClass("is-open")
              .removeClass("d-none"),
              $menuDislosure1
                .off("transitionend.toggleMenuLink1")
                .on("transitionend.toggleMenuLink1", () => {
                  $parent.hasClass("is-open") &&
                    !$parent.hasClass("is-hidden") &&
                    !$parent.hasClass("d-none") &&
                    $parent
                      .siblings()
                      .removeClass("is-open")
                      .addClass("is-hidden")
                      .removeClass("d-none");
                });
          }
        }
      ),
        $body.on(
          "click",
          ".site-nav-mobile .list-menu .menu_mobile_link_2",
          function (e) {
            e.preventDefault(), e.stopPropagation();
            var $target = $(this),
              $target = $(this),
              $parent = $target.parent().parent(),
              $menuDislosure2 = $target
                .parent()
                .find("ul.list-menu--disclosure-2"),
              $parentToScroll = $target
                .parent()
                .parent()
                .parent()
                .parent()
                .parent()
                .parent();
            $parent
              .removeClass("is-hidden")
              .addClass("is-open")
              .removeClass("d-none"),
              $menuDislosure2
                .off("transitionend.toggleMenuLink2")
                .on("transitionend.toggleMenuLink2", () => {
                  $parent.hasClass("is-open") &&
                    !$parent.hasClass("is-hidden") &&
                    !$parent.hasClass("d-none") &&
                    ($parent.addClass("d-none"),
                    $parent
                      .siblings()
                      .removeClass("is-open")
                      .addClass("is-hidden")
                      .removeClass("d-none"),
                    $parentToScroll.animate({ scrollTop: 0 }, 0));
                }),
              ($(".menu-dropdown").hasClass("megamenu_style_5") ||
                $(".menu-dropdown").hasClass("megamenu_style_4") ||
                $(".menu-dropdown").hasClass("megamenu_style_3") ||
                $(".menu-dropdown").hasClass("megamenu_style_2") ||
                $(".menu-dropdown").hasClass("megamenu_style_1")) &&
                $target.parents(".menu-dropdown").animate({ scrollTop: 0 }, 0),
              $target.parents(".menu-dropdown").addClass("is-overflow");
          }
        ),
        $body.on("click", ".nav-title-mobile", function (e) {
          e.preventDefault(), e.stopPropagation();
          var $target = $(this),
            $parentLv1 = $target.parent().parent().parent().parent(".is-open"),
            $parentLv2 = $target.parent().parent().parent(".is-open"),
            $parentLv3 = $target.parent().parent(".is-open");
          $parentLv1.siblings().removeClass("is-hidden"),
            $parentLv1.removeClass("is-open").removeClass("d-none"),
            $parentLv2.siblings().removeClass("is-hidden"),
            $parentLv2.removeClass("is-open").removeClass("d-none"),
            $parentLv3.siblings().removeClass("is-hidden"),
            $parentLv3.removeClass("is-open").removeClass("d-none"),
            $(".menu-dropdown").removeClass("is-overflow");
        }),
        window.mobile_menu != "default" &&
          $doc.on("click", "[data-mobile-menu-tab]", (event2) => {
            event2.preventDefault(), event2.stopPropagation();
            var tabItem = event2.currentTarget.closest("li"),
              tabTarget = event2.currentTarget.dataset.target;
            tabItem.classList.contains("is-active") ||
              document
                .querySelector("[data-navigation-tab-mobile]")
                .querySelectorAll("li")
                .forEach((element) => {
                  element != tabItem
                    ? element.classList.remove("is-active")
                    : (element.classList.add("is-active"),
                      document
                        .querySelectorAll('[id^="MenuMobileListSection-"]')
                        .forEach((tab) => {
                          tab.getAttribute("id") == tabTarget
                            ? (tab.classList.remove("is-hidden"),
                              tab.classList.add("is-visible"))
                            : (tab.classList.remove("is-visible"),
                              tab.classList.add("is-hidden"));
                        }));
                });
          }),
        $(document).on(
          "click",
          "[data-navigation-mobile] .no-megamenu .menu-lv-1__action",
          (event2) => {
            const hash = $(event2.currentTarget).attr("href").split("#")[1];
            hash != null &&
              hash != "" &&
              $(`#${hash}`).length &&
              ($("body").removeClass("menu_open"),
              $("html, body").animate(
                { scrollTop: $(`#${hash}`).offset().top },
                700
              ));
          }
        );
    },
    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1e3);
      const expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    initMultiTab: function () {
      let designMode,
        showMenu,
        check = !0;
      document.body.matches(".shopify-design-mode")
        ? (designMode = !0)
        : (designMode = !1),
        document.body.matches(".menu_open") ? (showMenu = !0) : (showMenu = !1);
      const loadMenuDefault = () => {
          check && ((check = !1), halo.initMobileMenuDefault(url));
        },
        loadMenuTab = () => {
          check && ((check = !1), halo.initMultiTabMobile());
        };
      if ($("[data-menu-tab]").length > 0) {
        $doc.on("click", "[data-menu-tab] li", (event2) => {
          var active2 = $(event2.currentTarget).data("load-page"),
            href = $(event2.currentTarget).attr("href");
          $.cookie("page-url", active2, { expires: 1, path: "/" });
        });
        var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
          pageUrl = $.cookie("page-url"),
          menuTabItem,
          logoTabItem,
          menuItem;
        window.location.pathname.indexOf("/pages/") !== -1 &&
          window.page_active &&
          window.page_active != pageUrl &&
          (this.setCookie("page-url", window.page_active, 1),
          (pageUrl = window.page_active)),
          pageUrl != null
            ? ((menuTabItem = $(`[data-load-page="${pageUrl}"]`)),
              (logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`)),
              (menuItem = $(`[data-load-menu-page="${pageUrl}"]`)))
            : ((menuTabItem = $("[data-load-page].is-active")),
              (logoTabItem = $("[data-load-logo-page].first")),
              (menuItem = $("[data-load-menu-page].is-active")));
        var menuTab = menuTabItem.closest("[data-menu-tab]");
        menuTab
          .find("[data-load-page]")
          .not(menuTabItem)
          .removeClass("is-active"),
          logoTabItem.siblings().removeClass("is-active"),
          menuItem.siblings().removeClass("is-active"),
          pageUrl != ""
            ? (logoTabItem.addClass("is-active"),
              menuTabItem.addClass("is-active"),
              menuItem.addClass("is-active"))
            : ($("[data-load-page]:nth-child(1)").addClass("is-active"),
              $("[data-load-logo-page]:nth-child(1)").addClass("is-active"),
              $("[data-load-menu-page]:nth-child(1)").addClass("is-active"));
        const header = menuTabItem.closest(".header");
        if (header && window.innerWidth < 1025) {
          const logoMobile = $(".header-mobile .header__heading-link"),
            logDesktop = header.find(".header__heading-link.is-active");
          if (logDesktop.data("logo-mobile") == null) {
            logoMobile.find("img").addClass("logo-show");
            return;
          } else
            logoMobile.html(
              `<img src="${logDesktop.data(
                "logo-mobile"
              )}" alt="${logDesktop.data(
                "logo-mobile-alt"
              )}" style="max-width: ${logoMobile.data(
                "logo-width"
              )}px; height: auto"/>`
            ),
              logoMobile.find("img").addClass("logo-show");
        }
        var active = $("[data-menu-tab] li.is-active").data("load-page"),
          url =
            window.routes.root +
            `/search?type=product&q=${active}&view=ajax_mega_menu`;
        $body.hasClass("template-index")
          ? $win.width() < 1025 &&
            (window.mobile_menu == "default"
              ? window.addEventListener(
                  "load",
                  () => {
                    designMode || showMenu
                      ? loadMenuDefault()
                      : document.body.addEventListener(
                          "click",
                          () => {
                            loadMenuDefault();
                          },
                          !1
                        );
                  },
                  !1
                )
              : window.addEventListener(
                  "load",
                  () => {
                    designMode || showMenu
                      ? loadMenuTab()
                      : document.body.addEventListener(
                          "click",
                          () => {
                            loadMenuTab();
                          },
                          !1
                        );
                  },
                  !1
                ))
          : $win.width() < 1025 &&
            (window.mobile_menu == "default"
              ? window.addEventListener(
                  "load",
                  () => {
                    designMode || showMenu
                      ? loadMenuDefault()
                      : document.body.addEventListener(
                          "click",
                          () => {
                            loadMenuDefault();
                          },
                          !1
                        );
                  },
                  !1
                )
              : window.addEventListener(
                  "load",
                  () => {
                    designMode || showMenu
                      ? loadMenuTab()
                      : document.body.addEventListener(
                          "click",
                          () => {
                            loadMenuTab();
                          },
                          !1
                        );
                  },
                  !1
                ));
      } else {
        var url = window.routes.root + "/search?view=ajax_mega_menu";
        $win.width() < 1025 &&
          (window.mobile_menu == "default"
            ? designMode || showMenu
              ? loadMenuDefault()
              : document.body.addEventListener(
                  "click",
                  () => {
                    loadMenuDefault();
                  },
                  !1
                )
            : window.addEventListener(
                "load",
                () => {
                  designMode || showMenu
                    ? loadMenuTab()
                    : document.body.addEventListener(
                        "click",
                        () => {
                          loadMenuTab();
                        },
                        !1
                      );
                },
                !1
              ));
      }
    },
    initMobileMenuDefault: function (url) {
      const menuMobile = $("[data-navigation-mobile]"),
        nav = $("#HeaderNavigation [data-navigation]"),
        style =
          nav.attr("style") != null
            ? nav.attr("style")
            : nav.closest("#HeaderNavigation").attr("style");
      $(".list-menu-loading").remove(),
        menuMobile.append(
          `<nav class="header__inline-menu" data-navigation role="navigation" style="${
            style ?? ""
          }">${nav.html() != null ? nav.html() : ""}</nav>`
        );
      const topLanCur = $(".top-language-currency"),
        lanCurMobile = $("#navigation-mobile .nav-currency-language");
      lanCurMobile.text().trim() == "" &&
        topLanCur.length > 0 &&
        lanCurMobile.append(
          `<div class="top-language-currency">${topLanCur.html()}</div>`
        );
    },
    initMultiTabMobile: function () {
      if ($win.width() < 1025 && window.mobile_menu == "custom") {
        var chk = !0,
          menuElement = $('[data-section-type="menu"]'),
          menuMobile = $("[data-navigation-mobile]"),
          menuTabMobile = $("[data-navigation-tab-mobile]");
        const loadMenu = () => {
          if (chk) {
            chk = !1;
            const content = document.createElement("div"),
              tab = document.createElement("ul");
            Object.assign(tab, { className: "menu-tab list-unstyled" }),
              tab.setAttribute("role", "menu"),
              menuElement.each((index2, element) => {
                var currentMenu = element
                  .querySelector("template")
                  .content.firstElementChild.cloneNode(!0);
                index2 == 0
                  ? currentMenu.classList.add("is-visible")
                  : currentMenu.classList.add("is-hidden"),
                  content.appendChild(currentMenu);
              }),
              content
                .querySelectorAll('[id^="MenuMobileListSection-"]')
                .forEach((element, index2) => {
                  var tabTitle = element.dataset.heading,
                    tabId = element.getAttribute("id"),
                    tabElement = document.createElement("li");
                  Object.assign(tabElement, { className: "item" }),
                    tabElement.setAttribute("role", "menuitem"),
                    index2 == 0 && tabElement.classList.add("is-active"),
                    (tabElement.innerHTML = `<a class="link" href="#" data-mobile-menu-tab data-target="${tabId}">${tabTitle}</a>`),
                    tab.appendChild(tabElement);
                }),
              $(".list-menu-loading").remove(),
              menuTabMobile.html(tab),
              menuMobile.html(content.innerHTML);
          }
        };
        document.body.matches(".menu_open") && loadMenu(),
          document.body.addEventListener(
            "click",
            () => {
              loadMenu();
            },
            !1
          );
      }
    },
    initMenu: function (url) {
      $(".header").hasClass("header-04") ||
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const navigation = html.querySelector("#HeaderNavigation");
            navigation &&
              navigation.innerHTML.trim().length &&
              (document.querySelector("#HeaderNavigation").innerHTML =
                navigation.innerHTML);
          })
          .catch((e) => {
            console.error(e);
          });
    },
    clickedActiveProductTabs: function () {
      const handler = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const $block = $(entry.target);
            if ($block.hasClass("ajax-loaded")) return;
            var listTabs = $block.find(".list-product-tabs"),
              tabLink = listTabs.find("[data-product-tabTop]"),
              tabContent = $block.find("[data-product-TabContent]"),
              limit = $block.data("limit"),
              linkActive = listTabs.find(".tab-links.active"),
              activeTab = $block.find(
                ".product-tabs-content .tab-content.active"
              );
            $block.hasClass("ajax-loaded") ||
              halo.doAjaxProductTabs(
                linkActive.data("href"),
                activeTab.find(".loading"),
                activeTab.find(".products-load"),
                $block.attr("sectionid"),
                limit,
                $block
              ),
              tabLink.off("click").on("click", function (e) {
                if (
                  (e.preventDefault(),
                  e.stopPropagation(),
                  !$(this).hasClass("active"))
                ) {
                  const curTab = $(this),
                    curTabContent = $(curTab.data("target"));
                  tabLink.removeClass("active"),
                    tabContent.removeClass("active"),
                    curTabContent.hasClass("loaded") ||
                      halo.doAjaxProductTabs(
                        curTab.data("href"),
                        curTabContent.find(".loading"),
                        curTabContent.find(".products-load"),
                        $block.attr("sectionid"),
                        limit
                      ),
                    curTab.addClass("active"),
                    curTabContent.addClass("active"),
                    curTabContent.find(".slick-slider").slick("refresh");
                }
              });
          }
        });
      };
      this.productBlock = document.querySelectorAll("[data-product-tab-block]");
      const config = { threshold: 0.1 };
      (this.observer = new IntersectionObserver(handler, config)),
        this.productBlock.forEach((block) => {
          this.observer.observe(block);
        });
    },
    doAjaxProductTabs: function (
      handle,
      loadingElm,
      curTabContent,
      sectionId,
      limit,
      self
    ) {
      $.ajax({
        type: "get",
        url: handle,
        data: { constraint: `sectionId=${handle}+limit=${limit}` },
        beforeSend: function () {
          self?.addClass("ajax-loaded");
        },
        success: function (data) {
          if (
            (curTabContent.parent().addClass("loaded"),
            handle != "?view=ajax_product_block")
          )
            if ($(data).text().trim() === "") noProduct(curTabContent);
            else {
              const res = halo.handleResponse($(data), 0, limit);
              curTabContent.html(res),
                window.wishlist.show &&
                  halo.setLocalStorageProductForWishlist(),
                halo.checkNeedToConvertCurrency() &&
                  Currency.convertAll(
                    window.shop_currency,
                    $("#currencies .active").attr("data-currency"),
                    "span.money",
                    "money_format"
                  );
            }
        },
        complete: function () {
          if (
            (curTabContent.hasClass("products-carousel")
              ? halo.productBlockSilder(curTabContent.parent())
              : curTabContent.hasClass("products-cursor") &&
                curTabContent.data("enable-hover") === "true" &&
                halo.productBlockScroller(curTabContent),
            window.review.show &&
              $(".shopify-product-reviews-badge").length > 0 &&
              window.SPR != null &&
              typeof window.SPR.registerCallbacks == "functions")
          )
            return (
              window.SPR.registerCallbacks(),
              window.SPR.initRatingHandler(),
              window.SPR.initDomEls(),
              window.SPR.loadProducts(),
              window.SPR.loadBadges()
            );
        },
        error: function (xhr, text) {
          noProduct(curTabContent);
        },
      });
      const noProduct = (curTabContent2) => {
        curTabContent2.html(
          '<p class="loading center">Sorry, there are no products in this collection</p>'
        );
      };
    },
    lookbookCarousel: function () {
      var lookbookCarousel = $(".lookbook-carousel"),
        itemToShow = lookbookCarousel.data("item-to-show"),
        itemDots = lookbookCarousel.data("item-dots"),
        itemDotsMb = lookbookCarousel.data("item-dots-mb"),
        itemArrows = lookbookCarousel.data("item-arrows"),
        itemArrowsMb = lookbookCarousel.data("item-arrows-mb");
      if (
        (lookbookCarousel.length > 0 &&
          lookbookCarousel.not(".slick-initialized") &&
          lookbookCarousel.slick({
            mobileFirst: !0,
            adaptiveHeight: !0,
            vertical: !1,
            infinite: !0,
            slidesToShow: itemToShow,
            slidesToScroll: itemToShow,
            arrows: itemArrowsMb,
            dots: itemDotsMb,
            autoplay: !1,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            rtl: window.rtl_slick,
            responsive: [
              {
                breakpoint: 1024,
                settings: { arrows: itemArrows, dots: itemDots },
              },
            ],
          }),
        lookbookCarousel.hasClass("enable_counter_number"))
      ) {
        var slickNext = lookbookCarousel.find(".slick-next");
        lookbookCarousel
          .closest(".special-banner__item--lookbook_banner")
          .find(".products-counter-number")
          .appendTo(slickNext),
          lookbookCarousel.on("afterChange", (event2) => {
            var slickIndex = lookbookCarousel
              .find(".slick-current")
              .data("slick-index");
            lookbookCarousel.find("#count-image").text(slickIndex + 1);
          });
      }
    },
    productBlockSilder: function (wrapper) {
      var productGrid = wrapper.find(".products-carousel"),
        itemToShow = productGrid.data("item-to-show"),
        itemDots = productGrid.data("item-dots"),
        itemDotsMb = productGrid.data("item-dots-mb"),
        itemArrows = productGrid.data("item-arrows"),
        itemArrowsMb = productGrid.data("item-arrows-mb"),
        isProductCard06 = document.body.classList.contains(
          "product-card-layout-06"
        );
      if (productGrid.length > 0) {
        if (productGrid.hasClass("slick-initialized")) return;
        if (productGrid.not(".slick-initialized")) {
          if (
            (isProductCard06 &&
              productGrid.on("init", () => {
                const selectOptionsHeight = productGrid
                  .find(".product .card-action")
                  .eq(0)
                  .height();
                productGrid
                  .find(".slick-list")
                  .css("padding-bottom", selectOptionsHeight + "px"),
                  productGrid.attr(
                    "data-slider-padding-bottom",
                    selectOptionsHeight
                  );
              }),
            productGrid.hasClass("enable_progress_bar"))
          ) {
            var progressBar = wrapper.find(".scrollbar-thumb");
            productGrid.on("init", (event2, slick) => {
              var percent =
                (slick.currentSlide / (slick.slideCount - 1)) * 100 + "%";
              progressBar.css("--percent", percent);
            });
          }
          if (
            (productGrid.slick({
              mobileFirst: !0,
              adaptiveHeight: !0,
              vertical: !1,
              infinite: !0,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: itemArrowsMb,
              dots: itemDotsMb,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 1599,
                  settings: {
                    arrows: itemArrows,
                    dots: itemDots,
                    get slidesToShow() {
                      return itemToShow != null && itemToShow !== ""
                        ? (this.slidesToShow = itemToShow)
                        : (this.slidesToShow = 1);
                    },
                    get slidesToScroll() {
                      return itemToShow != null &&
                        itemToShow !== "" &&
                        itemToShow !== 3.5 &&
                        itemToShow !== 4.5 &&
                        itemToShow !== 5.5
                        ? (this.slidesToScroll = itemToShow)
                        : (this.slidesToScroll = 1);
                    },
                    get initialSlide() {
                      return itemToShow == 3.5 ||
                        itemToShow == 4.5 ||
                        itemToShow == 5.5
                        ? (this.initialSlide = 0.5)
                        : (this.initialSlide = 0);
                    },
                  },
                },
                {
                  breakpoint: 1024,
                  settings: {
                    arrows: itemArrows,
                    dots: itemDots,
                    get slidesToShow() {
                      return itemToShow != null && itemToShow !== ""
                        ? itemToShow == 5 || itemToShow == 6
                          ? (this.slidesToShow = itemToShow - 1)
                          : productGrid.parents(".collection-column-2").length
                          ? (this.slidesToShow = 2)
                          : (this.slidesToShow = itemToShow)
                        : (this.slidesToShow = 1);
                    },
                    get slidesToScroll() {
                      return itemToShow != null &&
                        itemToShow !== "" &&
                        itemToShow !== 3.5 &&
                        itemToShow !== 4.5 &&
                        itemToShow !== 5.5
                        ? itemToShow == 5 || itemToShow == 6
                          ? (this.slidesToScroll = itemToShow - 1)
                          : productGrid.parents(".collection-column-2").length
                          ? (this.slidesToScroll = 2)
                          : (this.slidesToScroll = itemToShow)
                        : (this.slidesToScroll = 1);
                    },
                    get initialSlide() {
                      return itemToShow == 3.5 ||
                        itemToShow == 4.5 ||
                        itemToShow == 5.5
                        ? (this.initialSlide = 0.5)
                        : (this.initialSlide = 0);
                    },
                  },
                },
                {
                  breakpoint: 991,
                  settings: {
                    arrows: itemArrowsMb,
                    dots: itemDotsMb,
                    get slidesToShow() {
                      return productGrid.hasClass("has__banner_tab") ||
                        productGrid.parents(".product-block-has__banner").length
                        ? productGrid.parents(".product-block-has__banner")
                            .length &&
                          productGrid
                            .parents(".product-block-has__banner")
                            .data("width-banner") > 40
                          ? (this.slidesToShow = 2)
                          : (this.slidesToShow = 3)
                        : productGrid.parents(".collection-column-2").length
                        ? (this.slidesToShow = 2)
                        : itemToShow == 1
                        ? (this.slidesToShow = itemToShow)
                        : (this.slidesToShow = 4);
                    },
                    get slidesToScroll() {
                      return productGrid.hasClass("has__banner_tab") ||
                        productGrid.parents(".product-block-has__banner").length
                        ? productGrid.parents(".product-block-has__banner")
                            .length &&
                          productGrid
                            .parents(".product-block-has__banner")
                            .data("width-banner") > 40
                          ? (this.slidesToScroll = 2)
                          : (this.slidesToScroll = 3)
                        : productGrid.parents(".collection-column-2").length
                        ? (this.slidesToScroll = 2)
                        : itemToShow == 1
                        ? (this.slidesToScroll = itemToShow)
                        : (this.slidesToScroll = 4);
                    },
                    get initialSlide() {
                      return itemToShow == 3.5 ||
                        itemToShow == 4.5 ||
                        itemToShow == 5.5
                        ? (this.initialSlide = 0.5)
                        : (this.initialSlide = 0);
                    },
                  },
                },
                {
                  breakpoint: 767,
                  arrows: itemArrowsMb,
                  dots: itemDotsMb,
                  settings: {
                    get slidesToShow() {
                      return productGrid.hasClass("has__banner_tab") ||
                        productGrid.parents(".product-block-has__banner").length
                        ? (this.slidesToShow = 2)
                        : itemToShow == 1
                        ? (this.slidesToShow = itemToShow)
                        : (this.slidesToShow = 3);
                    },
                    get slidesToScroll() {
                      return productGrid.hasClass("has__banner_tab") ||
                        productGrid.parents(".product-block-has__banner").length
                        ? (this.slidesToScroll = 2)
                        : itemToShow == 1
                        ? (this.slidesToScroll = itemToShow)
                        : (this.slidesToScroll = 3);
                    },
                    get initialSlide() {
                      return itemToShow == 3.5 ||
                        itemToShow == 4.5 ||
                        itemToShow == 5.5
                        ? (this.initialSlide = 0.5)
                        : (this.initialSlide = 0);
                    },
                  },
                },
                {
                  breakpoint: 320,
                  arrows: itemArrowsMb,
                  dots: itemDotsMb,
                  settings: {
                    get slidesToShow() {
                      return itemToShow == 1
                        ? productGrid.hasClass(
                            "special-banner__products--slider"
                          ) ||
                          productGrid.hasClass("special-banner__products--grid")
                          ? (this.slidesToShow = 2)
                          : (this.slidesToShow = itemToShow)
                        : (this.slidesToShow = 2);
                    },
                    get slidesToScroll() {
                      return itemToShow == 1
                        ? (this.slidesToScroll = itemToShow)
                        : (this.slidesToScroll = 2);
                    },
                  },
                },
              ],
            }),
            productGrid.hasClass("enable_progress_bar") &&
              productGrid.on("afterChange", (event2, slick, nextSlide) => {
                var percent = (nextSlide / (slick.slideCount - 1)) * 100 + "%";
                progressBar.css("--percent", percent);
              }),
            productGrid.hasClass("enable_counter_number"))
          ) {
            var slickNext = productGrid.find(".slick-next");
            productGrid
              .closest(".halo-block, .special-banner__product")
              .find(".products-counter-number")
              .appendTo(slickNext),
              productGrid.on("afterChange", (event2) => {
                var slickIndex = productGrid
                  .find(".slick-current")
                  .data("slick-index");
                productGrid.find("#count-image").text(slickIndex + 1);
              });
          }
        }
      }
    },
    productBlockInfiniteScroll: function () {
      var productBlock = $("[data-product-block], [data-product-tab-block]");
      productBlock.each((index2, element) => {
        var $block = $(element),
          showMore = $block.find("[data-product-infinite]");
        showMore.length > 0 &&
          showMore.find(".button").on("click", (event2) => {
            var showMoreButton = $(event2.target);
            if (showMoreButton.hasClass("view-all"))
              window.location = showMoreButton.data("href");
            else {
              event2.preventDefault(),
                event2.stopPropagation(),
                showMoreButton.addClass("is-loading");
              var url = showMoreButton.attr("data-collection"),
                limit = showMoreButton.attr("data-limit"),
                swipe2 = showMoreButton.attr("data-swipe"),
                total = showMoreButton.attr("data-total"),
                image_ratio = showMoreButton.attr("data-image-ratio"),
                sectionId = showMoreButton.attr("sectionId"),
                page = parseInt(showMoreButton.attr("data-page"));
              halo.doProductBlockInfiniteScroll(
                url,
                total,
                limit,
                swipe2,
                image_ratio,
                sectionId,
                page,
                showMoreButton,
                $block
              );
            }
          });
      });
    },
    doProductBlockInfiniteScroll: function (
      url,
      total,
      limit,
      swipe2,
      image_ratio,
      sectionId,
      page,
      showMoreButton,
      $block
    ) {
      $.ajax({
        type: "get",
        url: window.routes.root + "/collections/" + url,
        cache: !1,
        data: {
          view: "ajax_product_block",
          constraint:
            "limit=" +
            limit +
            "+page=" +
            page +
            "+sectionId=" +
            sectionId +
            "+imageRatio=" +
            image_ratio +
            "+swipe=" +
            swipe2,
        },
        beforeSend: function () {},
        success: function (data) {
          const $productGrid = showMoreButton.closest(".tab-content").length
            ? showMoreButton.closest(".tab-content").find(".products-grid")
            : showMoreButton
                .closest(".halo-block-content")
                .find(".products-grid");
          let length = $productGrid.find(".product").length;
          const res = halo.handleResponse(
            $(data),
            length,
            $productGrid.data("products-to-show")
          );
          if (
            ($productGrid.append(res), length + res.length < $(data).length)
          ) {
            var text = window.button_load_more.default;
            showMoreButton.removeClass("is-loading"),
              showMoreButton.attr("data-page", page + 1),
              showMoreButton.find("span").text(text);
          } else if (
            Number(total) > $(data).length &&
            $(data).length <= length + res.length
          ) {
            var text = window.button_load_more.view_all;
            showMoreButton.find("span").text(text),
              showMoreButton.removeClass("is-loading"),
              showMoreButton
                .attr("data-href", window.routes.root + "/collections/" + url)
                .addClass("view-all");
          } else {
            var text = window.button_load_more.no_more;
            showMoreButton.find("span").text(text),
              showMoreButton.removeClass("is-loading"),
              showMoreButton.attr("disabled", "disabled");
          }
        },
        complete: function () {
          if (
            (halo.checkNeedToConvertCurrency() &&
              Currency.convertAll(
                window.shop_currency,
                $("#currencies .active").attr("data-currency"),
                "span.money",
                "money_format"
              ),
            window.review.show &&
              $(".shopify-product-reviews-badge").length > 0 &&
              window.SPR != null &&
              typeof window.SPR.registerCallbacks == "functions")
          )
            return (
              window.SPR.registerCallbacks(),
              window.SPR.initRatingHandler(),
              window.SPR.initDomEls(),
              window.SPR.loadProducts(),
              window.SPR.loadBadges()
            );
        },
      });
    },
    productMenuSlider: function () {
      var productGrid = $(".megamenu_style_5");
      productGrid.length > 0 &&
        productGrid.each((index2, el) => {
          let _self = $(el).find(".products-carousel"),
            _dataRows = _self.data("row");
          _self.not(".slick-initialized") &&
            _self.slick({
              mobileFirst: !0,
              adaptiveHeight: !0,
              vertical: !1,
              infinite: !1,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: !1,
              dots: !0,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: { slidesToShow: 3, slidesToScroll: 1 },
                },
                {
                  breakpoint: 1500,
                  settings: {
                    slidesToShow: _dataRows,
                    slidesToScroll: 1,
                    dots: !1,
                  },
                },
              ],
            });
        });
    },
    buildRecommendationBlock: function () {
      if (document.querySelector("[data-recommendations-block]") == null)
        return;
      var $this = document.querySelector("[data-recommendations-block]"),
        layout = $this.dataset.layout;
      swipe = $this.dataset.swipe;
      const config = { threshold: 0.25 },
        handleIntersection = (entries, observer) => {
          const recommendationsContainer =
            $this.querySelector(".wrapper-container");
          entries[0].isIntersecting &&
            (($this.innerHTML.trim() != "" &&
              !recommendationsContainer.classList.contains(
                "product-recommendations-loading"
              ) &&
              !recommendationsContainer.classList.contains("has-product")) ||
              (recommendationsContainer.classList.add("has-product"),
              fetch($this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                  const html = document.createElement("div");
                  html.innerHTML = text;
                  const recommendations = html.querySelector(
                    "[data-recommendations-block]"
                  );
                  if (
                    recommendations &&
                    recommendations.innerHTML.trim().length
                  ) {
                    $this.innerHTML = recommendations.innerHTML;
                    var productItems = $($this).find(".product-item"),
                      firstProductData = productItems
                        .eq(0)
                        .data("json-product");
                    if (!firstProductData) return $($this).remove();
                    if (layout == "slider") halo.productBlockSilder($($this));
                    else if (layout == "scroll") {
                      const enableHover = $($this)
                          .find("[data-enable-hover]")
                          .attr("data-enable-hover"),
                        wrapper = $this.closest(".products-flex");
                      enableHover === "true" &&
                        wrapper.clientWidth < wrapper.scrollWidth &&
                        halo.productBlockScroller($($this));
                    }
                    var productItems = $($this).find(".product-item");
                    productItems.each(async (index2, rawProduct) => {
                      var product = $(rawProduct),
                        productId = product.data("product-id"),
                        productJson = product.data("json-product"),
                        handle = productJson.handle;
                      await $.ajax({
                        type: "get",
                        url:
                          window.routes.root +
                          "/products/" +
                          handle +
                          "?view=ajax_variant_quantity",
                        beforeSend: function () {},
                        success: function (data) {
                          const element = new DOMParser().parseFromString(
                            data,
                            "text/html"
                          );
                          if (
                            element.querySelector(
                              `[data-quantity-product-id="${productId}"]`
                            )
                          ) {
                            const quantityInfo = JSON.parse(
                              element.querySelector(
                                `[data-quantity-product-id="${productId}"]`
                              ).innerHTML
                            );
                            window[`quick_view_inven_array_${productId}`] =
                              quantityInfo;
                          }
                        },
                        error: function (xhr, text2) {
                          halo.showWarning(
                            $.parseJSON(xhr.responseText).description
                          );
                        },
                        complete: function () {},
                      });
                    });
                    const loadingImages = $this.querySelectorAll(
                      ".media--loading-effect img"
                    );
                    if (
                      (this.observeImageLazyloaded(loadingImages),
                      window.compare.show)
                    ) {
                      var $compareLink = $("[data-compare-link]");
                      halo.setLocalStorageProductForCompare($compareLink);
                    }
                    if (
                      (window.wishlist.show &&
                        halo.setLocalStorageProductForWishlist(),
                      window.review.show &&
                        $(".shopify-product-reviews-badge").length > 0 &&
                        window.SPR != null &&
                        typeof window.SPR.registerCallbacks == "functions")
                    )
                      return (
                        window.SPR.registerCallbacks(),
                        window.SPR.initRatingHandler(),
                        window.SPR.initDomEls(),
                        window.SPR.loadProducts(),
                        window.SPR.loadBadges()
                      );
                    this.calculateTranslateYHeight();
                  }
                })
                .catch((e) => {
                  console.error(e);
                })));
        };
      new IntersectionObserver(handleIntersection.bind($this), config).observe(
        $this
      );
    },
    initVideoPopup: function () {
      $(".video-open-popup").length &&
        ($(".video-open-popup .video-button")
          .off("click")
          .on("click", function () {
            let video_type = $(this).attr("data-type"),
              video_src = $(this).attr("data-src"),
              aspect_ratio = $(this).attr("aspect_ratio"),
              modal = $("[data-popup-video]");
            const $content = `<div class="fluid-width-video-wrapper" style="padding-top: ${aspect_ratio}">
                                    ${
                                      video_type == "youtube"
                                        ? `<iframe
                                            id="player"
                                            type="text/html"
                                            width="100%"
                                            frameborder="0"
                                            webkitAllowFullScreen
                                            mozallowfullscreen
                                            allowFullScreen
                                            src="https://www.youtube.com/embed/${video_src}?autoplay=1&mute=1">
                                        </iframe>`
                                        : `<iframe 
                                            src="https://player.vimeo.com/video/${video_src}?autoplay=1&mute=1" 
                                            class="js-vimeo" 
                                            allow="autoplay; 
                                            encrypted-media" 
                                            webkitallowfullscreen 
                                            mozallowfullscreen 
                                            allowfullscreen">
                                        </iframe>`
                                    }
                                </div>`;
            modal.find(".halo-popup-content").html($content),
              $body.addClass("video-show");
          }),
        $(
          "[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay"
        ).on("click", function (e) {
          let modalContent = $("[data-popup-video] .halo-popup-content");
          !modalContent.is(e.target) &&
            !modalContent.has(e.target).length &&
            ($body.removeClass("video-show"),
            $("[data-popup-video] iframe").remove());
        }));
    },
    swapHoverVideoProductCard: function () {
      window.innerWidth > 1200 &&
        ($(".product-item .card").mouseenter(function () {
          var chil = $(this).find("video"),
            _chil = $(this).find("video").get(0);
          chil.length > 0 && _chil.play();
        }),
        $(".product-item .card").mouseleave(function () {
          var chil = $(this).find("video"),
            _chil = $(this).find("video").get(0);
          chil.length > 0 && _chil.pause();
        }));
    },
    initGlobalCheckbox: function () {
      $doc.on("change", ".global-checkbox--input", (event2) => {
        var targetId = event2.target.getAttribute("data-target");
        event2.target.checked
          ? $(targetId).attr("disabled", !1)
          : $(targetId).attr("disabled", !0);
      }),
        $doc.on("click", "[data-term-condition]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.addClass("term-condition-show");
        }),
        $doc.on("click", "[data-close-term-condition-popup]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.removeClass("term-condition-show");
        }),
        $doc.on("click", (event2) => {
          setTimeout(() => {
            $body.hasClass("cart-sidebar-show") &&
              $(event2.target).closest("[data-term-condition-popup]").length ===
                0 &&
              $body.removeClass("term-condition-show"),
              $body.hasClass("term-condition-show") &&
                $(event2.target).closest("[data-term-condition-popup]")
                  .length === 0 &&
                $body.removeClass("term-condition-show");
          }, 10);
        });
    },
    initColorSwatch: function () {
      $doc.ready(function () {
        $(".card .swatch-label.is-active").trigger("click");
      }),
        $doc.on("click", ".card .swatch-label", (event2) => {
          var $target = $(event2.currentTarget),
            title = $target.attr("title").replace(/^\s+|\s+$/g, ""),
            product = $target.closest(".product-item"),
            productJson = product.data("json-product"),
            productTitle = product.find(".card-title"),
            productAction = product.find("[data-btn-addtocart]"),
            variantId = $target.data("variant-id"),
            productHref = product.find("a").attr("href"),
            oneOption = $target.data("with-one-option"),
            newImage = $target.data("variant-img"),
            mediaList = [];
          $target
            .parents(".swatch")
            .find(".swatch-label")
            .removeClass("is-active"),
            $target.addClass("is-active"),
            productTitle.hasClass("card-title-change")
              ? $body.hasClass("style_2_text_color_varriant")
                ? productTitle.find("[data-change-title]").text(title)
                : productTitle.find("[data-change-title]").text(" - " + title)
              : $body.hasClass("style_2_text_color_varriant")
              ? productTitle
                  .addClass("card-title-change")
                  .append("<span data-change-title>" + title + "</span>")
              : productTitle
                  .addClass("card-title-change")
                  .append("<span data-change-title> - " + title + "</span>");
          const selectedVariant = productJson.variants.find(
            (variant) => variant.id === variantId
          );
          if (selectedVariant.compare_at_price > selectedVariant.price) {
            product.find(".price").addClass("price--on-sale"),
              product
                .find(".price__sale .price-item--regular")
                .html(
                  Shopify.formatMoney(
                    selectedVariant.compare_at_price,
                    window.money_format
                  )
                ),
              product
                .find(".price__sale .price-item--sale")
                .html(
                  Shopify.formatMoney(
                    selectedVariant.price,
                    window.money_format
                  )
                );
            const labelSale = `-${Math.round(
              ((selectedVariant.compare_at_price - selectedVariant.price) *
                100) /
                selectedVariant.compare_at_price
            )}%`;
            product.find(".price__label_sale .label_sale").html(labelSale);
          } else
            product
              .find(".price__regular .price-item")
              .html(
                Shopify.formatMoney(selectedVariant.price, window.money_format)
              ),
              selectedVariant.compare_at_price == null &&
                (product.find(".price").removeClass("price--on-sale"),
                product.find(".price__sale .price-item--regular").html(""));
          if (
            (product
              .find("a:not(.single-action):not(.number-showmore)")
              .attr(
                "href",
                productHref.split("?variant=")[0] + "?variant=" + variantId
              ),
            oneOption != null)
          ) {
            var quantity = $target.data("quantity");
            product.find('[name="id"]').val(oneOption),
              quantity > 0
                ? window.notify_me.show
                  ? productAction
                      .removeClass("is-notify-me")
                      .addClass("is-visible")
                  : productAction
                      .removeClass("is-soldout")
                      .addClass("is-visible")
                : window.notify_me.show
                ? productAction
                    .removeClass("is-visible")
                    .addClass("is-notify-me")
                : productAction
                    .removeClass("is-visible")
                    .addClass("is-soldout"),
              productAction.hasClass("is-soldout") ||
              productAction.hasClass("is-notify-me")
                ? productAction.hasClass("is-notify-me")
                  ? productAction.text(window.notify_me.button)
                  : productAction
                      .text(window.variantStrings.soldOut)
                      .prop("disabled", !0)
                : productAction
                    .text(window.variantStrings.addToCart)
                    .prop("disabled", !1);
          } else
            productJson != null &&
              window.quick_shop.show &&
              halo.checkStatusSwatchQuickShop(product, productJson),
              product
                .find('.swatch-element[data-value="' + title + '"]')
                .find(".single-label")
                .trigger("click");
          if (productJson.media != null)
            var mediaList = productJson.media.filter(
              (index2, element) => element.alt === title
            );
          if (mediaList.length > 0) {
            if (mediaList.length > 1) var length = 2;
            else var length = mediaList.length;
            for (var i = 0; i < length; i++)
              product
                .find(".card-media img:eq(" + i + ")")
                .attr("srcset", mediaList[i].src);
          } else
            newImage &&
              product
                .find(".card-media img:nth-child(1)")
                .attr("srcset", newImage)
                .attr("data-srcset", newImage);
          halo.checkNeedToConvertCurrency() &&
            Currency.convertAll(
              window.shop_currency,
              $("#currencies .active").attr("data-currency"),
              "span.money",
              "money_format"
            );
        }),
        $doc.on("click", ".item-swatch-more .number-showmore", (event2) => {
          $(event2.target).closest(".swatch").hasClass("show--more")
            ? ($(event2.target).closest(".swatch").removeClass("show--more"),
              $(event2.target).find("span:eq(0)").text("+"))
            : ($(event2.target).closest(".swatch").addClass("show--more"),
              $(event2.target).find("span:eq(0)").text("-"));
        });
    },
    checkPreOrderOfVariant: function (
      selectedVariant,
      productAction,
      productJson
    ) {
      const variantId = selectedVariant.id,
        updatePreOrderText = (
          productAction2,
          selectedVariant2,
          inventoryQuantity2
        ) => {
          const hasQuickShopPanel =
            productAction2
              .parents(".product-item")
              .find("[data-quickshop-popup]").length > 0;
          selectedVariant2.inventory_management == null
            ? productAction2
                .text(
                  hasQuickShopPanel
                    ? window.variantStrings.add
                    : window.variantStrings.addToCart
                )
                .prop("disabled", !1)
                .addClass("button--pre-untrack")
            : selectedVariant2.available && inventoryQuantity2 <= 0
            ? productAction2
                .text(window.variantStrings.preOrder)
                .prop("disabled", !1)
                .addClass("button--pre-untrack")
            : (productAction2.removeClass("button--pre-untrack"),
              inventoryQuantity2 > 0
                ? window.notify_me.show
                  ? productAction2
                      .removeClass("is-notify-me")
                      .addClass("is-visible")
                  : productAction2
                      .removeClass("is-soldout")
                      .addClass("is-visible")
                : window.notify_me.show
                ? productAction2
                    .removeClass("is-visible")
                    .addClass("is-notify-me")
                    .prop("disabled", !1)
                : productAction2
                    .removeClass("is-visible")
                    .addClass("is-soldout")
                    .prop("disabled", !0),
              productAction2.hasClass("is-soldout") ||
              productAction2.hasClass("is-notify-me")
                ? productAction2.hasClass("is-notify-me")
                  ? productAction2
                      .text(window.notify_me.button)
                      .prop("disabled", !1)
                      .removeClass("btn-unavailable")
                  : productAction2
                      .text(window.variantStrings.soldOut)
                      .prop("disabled", !0)
                : productAction2
                    .text(
                      hasQuickShopPanel
                        ? window.variantStrings.add
                        : window.variantStrings.addToCart
                    )
                    .prop("disabled", !1));
        },
        variantsQuantityInvenText = `quick_view_inven_array_${productJson.id}`;
      var arrayInVarName = variantsQuantityInvenText,
        inven_array = window[arrayInVarName];
      if (inven_array != null) {
        var inven_num = inven_array[variantId],
          inventoryQuantity = parseInt(inven_num);
        updatePreOrderText(productAction, selectedVariant, inventoryQuantity);
      } else
        $.ajax({
          type: "get",
          url:
            window.routes.root +
            "/products/" +
            productJson.handle +
            "?view=ajax_quick_shop_data",
          beforeSend: function () {},
          success: function (data) {
            window[variantsQuantityInvenText] = JSON.parse(data.split("=")[1]);
            var inven_num2 = window[variantsQuantityInvenText][variantId],
              inventoryQuantity2 = parseInt(inven_num2);
            updatePreOrderText(
              productAction,
              selectedVariant,
              inventoryQuantity2
            );
          },
          error: function (xhr, text) {
            halo.showWarning($.parseJSON(xhr.responseText).description);
          },
          complete: function () {},
        });
    },
    initQuickShop: function () {
      window.quick_shop.show &&
        ($doc.on("click", "[data-quickshop-popup]", (event2) => {
          event2.preventDefault(), event2.stopPropagation();
          var $target = $(event2.target),
            product = $target.parents(".product-item"),
            productJson = product.data("json-product"),
            variantPopup = product.find(".variants-popup");
          const $quickView = document.querySelector(".halo-quick-view-popup");
          if (
            (!document.body.matches(".qv-loaded", ".qs3-loaded") &&
              $quickView &&
              (halo.buildStyleSheet(
                $quickView.dataset.urlStyleProduct,
                $quickView
              ),
              document.body.classList.add("qs3-loaded")),
            product.hasClass("quickshop-popup-show"))
          )
            halo.initAddToCartQuickShop($target, variantPopup);
          else {
            if (
              ($(".product-item").removeClass("quickshop-popup-show"),
              $body.hasClass("quick_shop_option_2"))
            ) {
              var height = product.find(".card-media").outerHeight(!0),
                variantsArray = variantPopup.find(".variants");
              $body.hasClass("product-card-layout-02")
                ? $win.width() > 1024
                  ? (variantsArray.css("max-height", height - 114 + "px"),
                    variantsArray.css("min-height", height - 114 + "px"))
                  : (variantsArray.css("max-height", height - 70 + "px"),
                    variantsArray.css("min-height", height - 70 + "px"))
                : $body.hasClass("product-card-layout-04")
                ? $win.width() > 1024
                  ? (variantsArray.css("max-height", height - 116 + "px"),
                    variantsArray.css("min-height", height - 116 + "px"))
                  : (variantsArray.css("max-height", height - 70 + "px"),
                    variantsArray.css("min-height", height - 70 + "px"))
                : $win.width() > 1024
                ? (variantsArray.css("max-height", height - 74 + "px"),
                  variantsArray.css("min-height", height - 74 + "px"))
                : (variantsArray.css("max-height", height - 20 + "px"),
                  variantsArray.css("min-height", height - 20 + "px")),
                variantsArray[0].scrollHeight > variantsArray[0].clientHeight &&
                  variantsArray.addClass("scrollable"),
                $(".productListing").hasClass("productList") ||
                  halo.appendProductQuickShopOption2(product);
            } else if ($body.hasClass("quick_shop_option_3")) {
              const handle = $target.data("product-handle");
              $(".productListing").hasClass("productList") ||
                halo.updateContentQuickshopOption3(handle),
                $doc.on("click", "[data-close-quick-shop-popup]", (event3) => {
                  event3.preventDefault(),
                    event3.stopPropagation(),
                    $body.removeClass("quickshop-popup-show");
                }),
                $doc
                  .off("click.quickShopOverlay")
                  .on("click.quickShopOverlay", (event3) => {
                    $body.hasClass("quickshop-popup-show") &&
                      $(event3.target).is(".background-overlay") &&
                      $body.removeClass("quickshop-popup-show");
                  });
            }
            if (
              ($body.hasClass("quick_shop_option_3")
                ? $(".productListing").hasClass("productList") &&
                  ($win.width() < 767
                    ? halo.appendToListViewModal(product)
                    : product.addClass("quickshop-popup-show"))
                : $win.width() < 767 &&
                  $(".productListing").hasClass("productList")
                ? halo.appendToListViewModal(product)
                : product.addClass("quickshop-popup-show"),
              product.find(".swatch-label.is-active").trigger("click"),
              halo.checkStatusSwatchQuickShop(product, productJson),
              $body.hasClass("quick_shop_option_2") ||
                ($("productListing").hasClass("productList") &&
                  !$(".card-swatch").hasClass("quick_shop_type_3")))
            ) {
              if ($win.width() < 767)
                if ($(".productListing").hasClass("productList"))
                  variantPopup
                    .find(".selector-wrapper")
                    .each((index2, element) => {
                      $(element)
                        .find(".swatch-element:not(.soldout):not(.unavailable)")
                        .eq("0")
                        .find(".single-label")
                        .trigger("click");
                    });
                else {
                  var quickshopVariantPopup = $(
                    "#halo-card-mobile-popup .variants-popup"
                  );
                  quickshopVariantPopup
                    .find(".selector-wrapper")
                    .each((index2, element) => {
                      $(element)
                        .find(".swatch-element:not(.soldout):not(.unavailable)")
                        .eq("0")
                        .find(".single-label")
                        .trigger("click");
                    });
                }
              else
                variantPopup
                  .find(".selector-wrapper")
                  .each((index2, element) => {
                    $(element)
                      .find(".swatch-element:not(.soldout):not(.unavailable)")
                      .eq("0")
                      .find(".single-label")
                      .trigger("click");
                  });
              $(".productListing").hasClass("productList") ||
                $body.addClass("quick_shop_popup_mobile");
            } else
              variantPopup
                .find(".selector-wrapper:not(.option-color)")
                .each((index2, element) => {
                  $(element)
                    .find(".swatch-element:not(.soldout):not(.unavailable)")
                    .eq("0")
                    .find(".single-label")
                    .trigger("click");
                });
          }
          halo.checkNeedToConvertCurrency() &&
            Currency.convertAll(
              window.shop_currency,
              $("#currencies .active").attr("data-currency"),
              "span.money",
              "money_format"
            );
        }),
        $doc.on("click", "[data-cancel-quickshop-popup]", (event2) => {
          event2.preventDefault(), event2.stopPropagation();
          var $target = $(event2.currentTarget),
            product = $target.parents(".product-item"),
            quickshopMobilePopup = $doc.find("#halo-card-mobile-popup");
          product.removeClass("quickshop-popup-show");
          var productQuickshopShown = $doc.find(".quickshop-popup-show");
          productQuickshopShown.removeClass("quickshop-popup-show"),
            $body.removeClass("quickshop-list-view-show"),
            $body.hasClass("quick_shop_option_2") &&
              ($body.removeClass("quick_shop_popup_mobile"),
              quickshopMobilePopup.removeClass("show"));
        }),
        $doc.on("click", (event2) => {
          $(event2.target).closest("[data-quickshop-popup]").length === 0 &&
            $(event2.target).closest(".variants-popup").length === 0 &&
            $(event2.target).closest(".card-swatch").length === 0 &&
            $(event2.target).closest("[data-warning-popup]").length === 0 &&
            ($(".product-item").removeClass("quickshop-popup-show"),
            $body.hasClass("quick_shop_option_2") &&
              $body.removeClass("quick_shop_popup_mobile"));
        }),
        halo.changeSwatchQuickShop());
    },
    appendToListViewModal: function (product) {
      const quickshopMobilePopup = $doc.find("#list-view-popup"),
        quickshopForm = product.clone();
      quickshopMobilePopup.find(".halo-popup-content").empty(),
        quickshopMobilePopup.find(".halo-popup-content").append(quickshopForm);
      const form = quickshopMobilePopup
          .find("[data-quickshop] .card-information .variants-popup form")
          .eq("0"),
        mobilePopupId = form.attr("id") + "-mobile",
        optionInputs = form.find(".single-option"),
        optionLabels = form.find(".single-label"),
        cardInfoWrapper = quickshopMobilePopup.find(".card-product"),
        variantsPopup = quickshopMobilePopup.find(".variants-popup"),
        submitBtn = quickshopMobilePopup.find("[data-btn-addtocart]");
      variantsPopup.removeClass("card-list__hidden");
      let clicked = { selected1: !1, selected2: !1, selected3: !1 };
      form.attr("id", mobilePopupId),
        submitBtn.attr(
          "data-form-id",
          submitBtn.attr("data-form-id") + "-mobile"
        ),
        optionInputs.each((index2, optionInput) => {
          $(optionInput).attr("id", $(optionInput).attr("id") + "-mobile"),
            $(optionInput).attr(
              "name",
              $(optionInput).attr("name") + "-mobile"
            );
        }),
        optionLabels.each((index2, optionLabel) => {
          $(optionLabel).attr("for", $(optionLabel).attr("for") + "-mobile");
          const swatchWrapper = $(optionLabel).closest(".selector-wrapper");
          $(optionLabel).closest(".swatch-element").hasClass("available") &&
            (swatchWrapper.hasClass("selector-wrapper-1") && !clicked.selected1
              ? ((clicked.selected1 = !0), $(optionLabel).trigger("click"))
              : swatchWrapper.hasClass("selector-wrapper-2") &&
                !clicked.selected2
              ? ((clicked.selected2 = !0), $(optionLabel).trigger("click"))
              : swatchWrapper.hasClass("selector-wrapper-3") &&
                !clicked.selected3 &&
                ((clicked.selected3 = !0), $(optionLabel).trigger("click")));
        }),
        $body.addClass("quickshop-list-view-show"),
        $(".background-overlay")
          .off("click.closeListViewModal")
          .on("click.closeListViewModal", () => {
            $body.removeClass("quickshop-list-view-show");
          });
    },
    changeSwatchQuickShop: function () {
      $doc.on("change", "[data-quickshop] .single-option", (event2) => {
        var $target = $(event2.target),
          product = $target.parents(".product-item"),
          productJson = product.data("json-product"),
          productAction = product.find("[data-btn-addtocart]"),
          variantList,
          optionColor = product.find(".option-color").data("option-position"),
          optionIndex = $target
            .closest("[data-option-index]")
            .data("option-index"),
          swatch = product.find(".swatch-element"),
          thisVal = $target.val(),
          selectedVariant,
          productInput = product.find("[name=id]"),
          selectedOption1 = product
            .find(".selector-wrapper-1")
            .find("input:checked")
            .val(),
          selectedOption2 = product
            .find(".selector-wrapper-2")
            .find("input:checked")
            .val(),
          selectedOption3 = product
            .find(".selector-wrapper-3")
            .find("input:checked")
            .val();
        switch (
          ($body.hasClass("quick_shop_option_2") &&
          $(".productListing").hasClass("productList")
            ? (selectedOption1 = product
                .find(".selector-wrapper-1")
                .eq("1")
                .find("input:checked")
                .val())
            : $(".productListing").hasClass("productList") && $win.width() < 767
            ? ((selectedOption1 = product
                .find(".selector-wrapper-1")
                .eq("1")
                .find("input:checked")
                .val()),
              (selectedOption2 = product
                .find('[data-option-index="1"]')
                .eq("1")
                .find("input:checked")
                .val()))
            : (selectedOption1 = product
                .find(".selector-wrapper-1")
                .eq("0")
                .find("input:checked")
                .val()),
          productJson != null && (variantList = productJson.variants),
          swatch.removeClass("soldout"),
          swatch.find('input[type="radio"]').prop("disabled", !1),
          optionIndex)
        ) {
          case 0:
            var availableVariants = variantList.find((variant) =>
              optionColor == 1
                ? variant.option2 == thisVal &&
                  variant.option1 == selectedOption2
                : optionColor == 2
                ? variant.option3 == thisVal &&
                  variant.option1 == selectedOption2
                : variant.option1 == thisVal &&
                  variant.option2 == selectedOption2
            );
            if (availableVariants != null) selectedVariant = availableVariants;
            else {
              var altAvailableVariants = variantList.find((variant) =>
                optionColor == 1
                  ? variant.option2 == thisVal
                  : optionColor == 2
                  ? variant.option3 == thisVal
                  : variant.option1 == thisVal
              );
              selectedVariant = altAvailableVariants;
            }
            break;
          case 1:
            var availableVariants = variantList.find((variant) =>
              optionColor == 1
                ? variant.option2 == selectedOption1 &&
                  variant.option1 == thisVal &&
                  variant.option3 == selectedOption2
                : optionColor == 2
                ? variant.option3 == selectedOption1 &&
                  variant.option1 == thisVal &&
                  variant.option2 == selectedOption2
                : variant.option1 == selectedOption1 &&
                  variant.option2 == thisVal &&
                  variant.option3 == selectedOption2
            );
            if (availableVariants != null) selectedVariant = availableVariants;
            else {
              var altAvailableVariants = variantList.find((variant) =>
                optionColor == 1
                  ? variant.option2 == selectedOption1 &&
                    variant.option1 == thisVal
                  : optionColor == 2
                  ? variant.option3 == selectedOption1 &&
                    variant.option1 == thisVal
                  : variant.option1 == selectedOption1 &&
                    variant.option2 == thisVal
              );
              selectedVariant = altAvailableVariants;
            }
            break;
          case 2:
            var availableVariants = variantList.find((variant) =>
              optionColor == 1
                ? variant.option2 == selectedOption1 &&
                  variant.option1 == selectedOption2 &&
                  variant.option3 == thisVal
                : optionColor == 2
                ? variant.option3 == selectedOption1 &&
                  variant.option1 == selectedOption2 &&
                  variant.option2 == thisVal
                : variant.option1 == selectedOption1 &&
                  variant.option2 == selectedOption2 &&
                  variant.option3 == thisVal
            );
            availableVariants != null && (selectedVariant = availableVariants);
            break;
        }
        if (selectedVariant != null) {
          productInput.val(selectedVariant.id);
          var value = $target.val();
          $target
            .parents(".selector-wrapper")
            .find(".form-label span")
            .text(value),
            selectedVariant.available
              ? (product
                  .find("[data-btn-addtocart]")
                  .removeClass("btn-unavailable"),
                product
                  .find("[data-quickshop] quickshop-update-quantity")
                  .removeClass("disabled"),
                product
                  .find("[data-btn-addtocart]")
                  .attr("data-available", "true"))
              : (product
                  .find("[data-btn-addtocart]")
                  .addClass("btn-unavailable"),
                product
                  .find("[data-quickshop] quickshop-update-quantity")
                  .addClass("disabled"),
                product
                  .find("[data-btn-addtocart]")
                  .attr("data-available", "false")),
            halo.checkNeedToConvertCurrency() &&
              Currency.convertAll(
                window.shop_currency,
                $("#currencies .active").attr("data-currency"),
                "span.money",
                "money_format"
              ),
            !$body.hasClass("quick_shop_option_2") &&
              !$body.hasClass("quick_shop_option_3") &&
              $win.width() < 767,
            halo.checkStatusSwatchQuickShop(product, productJson),
            halo.checkPreOrderOfVariant(
              selectedVariant,
              productAction,
              productJson
            );
        }
      });
    },
    checkStatusSwatchQuickShop: function (product, productJson) {
      var variantPopup = product.find(".card-variant"),
        variantList,
        productOption = product.find("[data-option-index]"),
        optionColor = product.find(".option-color").data("option-position"),
        selectedOption1 = product
          .find('[data-option-index="0"]')
          .find("input:checked")
          .val(),
        selectedOption2 = product
          .find('[data-option-index="1"]')
          .find("input:checked")
          .val(),
        selectedOption3 = product
          .find('[data-option-index="2"]')
          .find("input:checked")
          .val(),
        productId = product.data("product-id");
      if ($body.hasClass("quick_shop_option_2")) {
        var height = product.find(".card-media").outerHeight(!0);
        selectedOption3 != null
          ? $body.hasClass("product-card-layout-01")
            ? height < 310
              ? $("[data-quickshop]").addClass("active_option_3")
              : $("[data-quickshop]").removeClass("active_option_3")
            : height < 370
            ? $("[data-quickshop]").addClass("active_option_3")
            : $("[data-quickshop]").removeClass("active_option_3")
          : $win.width() > 1024
          ? $body.hasClass("product-card-layout-05")
            ? height < 350 && selectedOption2 != null
              ? $("[data-quickshop]").addClass("active_option_3")
              : $("[data-quickshop]").removeClass("active_option_3")
            : $body.hasClass("product-card-layout-01")
            ? height < 310 && selectedOption2 != null
              ? $("[data-quickshop]").addClass("active_option_3")
              : $("[data-quickshop]").removeClass("active_option_3")
            : height < 370 && selectedOption2 != null
            ? $("[data-quickshop]").addClass("active_option_3")
            : $("[data-quickshop]").removeClass("active_option_3")
          : $body.hasClass("product-card-layout-01")
          ? height < 310
            ? selectedOption1 != null || selectedOption2 != null
              ? $("[data-quickshop]").removeClass("active_option_3")
              : $("[data-quickshop]").addClass("active_option_3")
            : $("[data-quickshop]").removeClass("active_option_3")
          : height < 370
          ? selectedOption1 != null || selectedOption2 != null
            ? $("[data-quickshop]").removeClass("active_option_3")
            : $("[data-quickshop]").addClass("active_option_3")
          : $("[data-quickshop]").removeClass("active_option_3");
      }
      if (
        ($body.hasClass("quick_shop_option_2") &&
        $(".productListing").hasClass("productList")
          ? (selectedOption1 = product
              .find('[data-option-index="0"]')
              .eq("1")
              .find("input:checked")
              .val())
          : $(".productListing").hasClass("productList") && $win.width() < 767
          ? ((selectedOption1 = product
              .find('[data-option-index="0"]')
              .eq("1")
              .find("input:checked")
              .val()),
            (selectedOption2 = product
              .find('[data-option-index="1"]')
              .eq("1")
              .find("input:checked")
              .val()))
          : (selectedOption1 = product
              .find('[data-option-index="0"]')
              .eq("0")
              .find("input:checked")
              .val()),
        productJson != null && (variantList = productJson.variants),
        productOption.each((index2, element) => {
          var optionIndex = $(element).data("option-index"),
            swatch = $(element).find(".swatch-element");
          switch (optionIndex) {
            case 0:
              swatch.each((idx, elt) => {
                var item = $(elt),
                  swatchVal = item.data("value"),
                  optionSoldout = variantList.find((variant) =>
                    optionColor == 1
                      ? variant.option2 == swatchVal && variant.available
                      : optionColor == 2
                      ? variant.option3 == swatchVal && variant.available
                      : variant.option1 == swatchVal && variant.available
                  ),
                  optionUnavailable = variantList.find((variant) =>
                    optionColor == 1
                      ? variant.option2 == swatchVal
                      : optionColor == 2
                      ? variant.option3 == swatchVal
                      : variant.option1 == swatchVal
                  );
                optionSoldout == null
                  ? optionUnavailable == null
                    ? (item
                        .removeClass("soldout available")
                        .addClass("unavailable"),
                      item.find('input[type="radio"]').prop("checked", !1))
                    : (item
                        .removeClass("unavailable available")
                        .addClass("soldout")
                        .find(".single-action")
                        .attr("data-variant-id", optionUnavailable.title),
                      item.find('input[type="radio"]').prop("disabled", !1))
                  : (item
                      .removeClass("soldout unavailable")
                      .addClass("available"),
                    item.find('input[type="radio"]').prop("disabled", !1));
              });
              break;
            case 1:
              swatch.each((idx, elt) => {
                var item = $(elt),
                  swatchVal = item.data("value"),
                  optionSoldout = variantList.find((variant) =>
                    optionColor == 1
                      ? variant.option2 == selectedOption1 &&
                        variant.option1 == swatchVal &&
                        variant.available
                      : optionColor == 2
                      ? variant.option3 == selectedOption1 &&
                        variant.option1 == swatchVal &&
                        variant.available
                      : variant.option1 == selectedOption1 &&
                        variant.option2 == swatchVal &&
                        variant.available
                  ),
                  optionUnavailable = variantList.find((variant) =>
                    optionColor == 1
                      ? variant.option2 == selectedOption1 &&
                        variant.option1 == swatchVal
                      : optionColor == 2
                      ? variant.option3 == selectedOption1 &&
                        variant.option1 == swatchVal
                      : variant.option1 == selectedOption1 &&
                        variant.option2 == swatchVal
                  );
                optionSoldout == null
                  ? optionUnavailable == null
                    ? (item
                        .removeClass("soldout available")
                        .addClass("unavailable"),
                      item.find('input[type="radio"]').prop("checked", !1))
                    : (item
                        .removeClass("unavailable available")
                        .addClass("soldout")
                        .find(".single-action-selector")
                        .attr("data-variant-id", optionUnavailable.title),
                      item.find('input[type="radio"]').prop("disabled", !1))
                  : (item
                      .removeClass("soldout unavailable")
                      .addClass("available"),
                    item.find('input[type="radio"]').prop("disabled", !1));
              });
              break;
            case 2:
              swatch.each((idx, elt) => {
                var item = $(elt),
                  swatchVal = item.data("value"),
                  optionSoldout = variantList.find((variant) =>
                    optionColor == 1
                      ? variant.option2 == selectedOption1 &&
                        variant.option1 == selectedOption2 &&
                        variant.option3 == swatchVal &&
                        variant.available
                      : optionColor == 2
                      ? variant.option3 == selectedOption1 &&
                        variant.option1 == selectedOption2 &&
                        variant.option2 == swatchVal &&
                        variant.available
                      : variant.option1 == selectedOption1 &&
                        variant.option2 == selectedOption2 &&
                        variant.option3 == swatchVal &&
                        variant.available
                  ),
                  optionUnavailable = variantList.find((variant) =>
                    optionColor == 1
                      ? variant.option2 == selectedOption1 &&
                        variant.option1 == selectedOption2 &&
                        variant.option3 == swatchVal
                      : optionColor == 2
                      ? variant.option3 == selectedOption1 &&
                        variant.option1 == selectedOption2 &&
                        variant.option2 == swatchVal
                      : variant.option1 == selectedOption1 &&
                        variant.option2 == selectedOption2 &&
                        variant.option3 == swatchVal
                  );
                optionSoldout == null
                  ? optionUnavailable == null
                    ? (item
                        .removeClass("soldout available")
                        .addClass("unavailable"),
                      item.find('input[type="radio"]').prop("checked", !1))
                    : (item
                        .removeClass("unavailable available")
                        .addClass("soldout")
                        .find(".single-action-selector")
                        .attr("data-variant-id", optionUnavailable.title),
                      item.find('input[type="radio"]').prop("disabled", !1))
                  : (item
                      .removeClass("unavailable soldout")
                      .addClass("available"),
                    item.find('input[type="radio"]').prop("disabled", !1));
              });
              break;
          }
        }),
        variantPopup
          .find(".selector-wrapper:not(.option-color)")
          .each((index2, element) => {
            var item = $(element);
            item.find(".swatch-element").find("input:checked").length < 1 &&
              (item.find(".swatch-element.available").length > 0
                ? item
                    .find(".swatch-element.available")
                    .eq("0")
                    .find(".single-label")
                    .trigger("click")
                : item
                    .find(".swatch-element.soldout")
                    .eq("0")
                    .find(".single-label")
                    .trigger("click"));
          }),
        $body.hasClass("quick_shop_option_2"))
      ) {
        var variantId = product
            .find("[data-quickshop]")
            .eq(1)
            .find('[name="id"]')
            .val(),
          arrayInVarName = `quick_view_inven_array_${productId}`,
          inven_array = window[arrayInVarName];
        if (inven_array != null) {
          var inven_num = inven_array[variantId],
            inventoryQuantity = parseInt(inven_num),
            quantityInput = product.find('input[name="quantity"]').eq(0);
          quantityInput.attr("data-inventory-quantity", inventoryQuantity),
            quantityInput.val() > inventoryQuantity &&
              (inventoryQuantity > 0
                ? quantityInput.val(inventoryQuantity)
                : quantityInput.val(1));
        }
      }
    },
    initAddToCartQuickShop: function ($target, popup) {
      var variantId = popup.find('[name="id"]').val(),
        qty = 1;
      halo.actionAddToCart($target, variantId, qty);
    },
    initAddToCart: function () {
      $doc
        .off("click.addToCart")
        .on("click.addToCart", "[data-btn-addtocart]", (event2) => {
          event2.preventDefault(), event2.stopPropagation();
          var $target = $(event2.target),
            product = $target.parents(".product-item"),
            MobilePopup_Option_2 = $doc.find("#halo-card-mobile-popup"),
            ProductQuickShopShown_Option_2 = $doc.find(".quickshop-popup-show");
          if ($target.closest("product-form").length > 0) {
            var productForm = $target.closest("form");
            halo.actionAddToCart2($target, productForm);
          } else if (
            !$target.hasClass("is-notify-me") &&
            !$target.hasClass("is-soldout")
          ) {
            var form = $target.parents("form"),
              variantId = form.find('[name="id"]').val(),
              qty = form.find('[name="quantity"]').val(),
              input = form.find('[name="quantity"]').eq(0);
            qty == null && (qty = 1),
              $(".recipient-form").length > 0
                ? $("#product-add-to-cart").trigger("click")
                : halo.actionAddToCart($target, variantId, qty, input);
          } else
            $target.hasClass("is-notify-me") &&
              halo.notifyInStockPopup($target);
        }),
        $doc.on("click", "[data-close-add-to-cart-popup]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.removeClass("add-to-cart-show");
        }),
        $doc.on("click", (event2) => {
          $body.hasClass("add-to-cart-show") &&
            $(event2.target).closest("[data-add-to-cart-popup]").length === 0 &&
            $body.removeClass("add-to-cart-show");
        });
    },
    actionAddToCart: function ($target, variantId, qty, input) {
      var originalMessage = window.variantStrings.submit,
        waitMessage = window.variantStrings.addingToCart,
        successMessage = window.variantStrings.addedToCart;
      $target.hasClass("button-text-change") &&
        (originalMessage = $target.text()),
        $target.addClass("is-loading"),
        $body.hasClass("quick-view-show")
          ? Shopify.addItem(
              variantId,
              qty,
              $target,
              () => {
                window.after_add_to_cart.type == "cart"
                  ? halo.redirectTo(window.routes.cart)
                  : Shopify.getCart((cartTotal) => {
                      $body.addClass("cart-sidebar-show"),
                        halo.updateSidebarCart(cartTotal),
                        $body
                          .find("[data-cart-count]")
                          .text(cartTotal.item_count),
                        $target.removeClass("is-loading");
                    });
              },
              input
            )
          : $body.hasClass("template-cart")
          ? Shopify.addItem(
              variantId,
              qty,
              $target,
              () => {
                halo.redirectTo(window.routes.cart);
              },
              input
            )
          : Shopify.addItem(
              variantId,
              qty,
              $target,
              () => {
                switch (
                  ($target.removeClass("is-loading"),
                  $body.hasClass("quickshop-popup-show") &&
                    $body.hasClass("quick_shop_option_3") &&
                    ($body.removeClass("quickshop-popup-show"),
                    $(".quickshop-popup-show").removeClass(
                      "quickshop-popup-show"
                    )),
                  $body.hasClass("quickshop-list-view-show") &&
                    $body.removeClass("quickshop-list-view-show"),
                  $body.hasClass("show-mobile-options") &&
                    ($body.removeClass("show-mobile-options"),
                    $(".background-overlay").addClass("hold")),
                  $body.hasClass("quick_shop_popup_mobile") &&
                    $body.hasClass("quick_shop_option_2") &&
                    ($body.removeClass("quick_shop_popup_mobile"),
                    $doc.find("#halo-card-mobile-popup").removeClass("show"),
                    $doc.find(".quickshop-popup-show").each((index2, popup) => {
                      $(popup).removeClass("quickshop-popup-show");
                    })),
                  window.after_add_to_cart.type)
                ) {
                  case "cart":
                    halo.redirectTo(window.routes.cart);
                    break;
                  case "quick_cart":
                    window.quick_cart.show
                      ? Shopify.getCart((cart) => {
                          window.quick_cart.type == "popup" ||
                            ($body.addClass("cart-sidebar-show"),
                            halo.updateSidebarCart(cart)),
                            $target.removeClass("is-loading"),
                            $(".background-overlay").removeClass("hold");
                        })
                      : halo.redirectTo(window.routes.cart);
                    break;
                  case "popup_cart_1":
                    Shopify.getCart((cart) => {
                      halo.updatePopupCart(cart, 1, variantId),
                        halo.updateSidebarCart(cart),
                        $body.addClass("add-to-cart-show"),
                        $target.removeClass("is-loading"),
                        $(".background-overlay").removeClass("hold");
                    });
                    break;
                }
              },
              input
            );
    },
    actionAddToCart2: function ($target, productForm) {
      const config = fetchConfig("javascript");
      var originalMessage = window.variantStrings.submit,
        waitMessage = window.variantStrings.addingToCart,
        successMessage = window.variantStrings.addedToCart;
      $target.hasClass("button-text-change") &&
        (originalMessage = $target.text()),
        $target.addClass("is-loading");
      let addToCartForm = document.querySelector(
          '[data-type="add-to-cart-form"]'
        ),
        formData = new FormData(addToCartForm);
      if (
        (document
          .querySelectorAll('[name^="properties"]')
          .forEach((property) => {
            property.value != null &&
              (property.type == "file"
                ? formData.append(property.name, property.files[0])
                : formData.append(property.name, property.value));
          }),
        !halo.checkSufficientStock(productForm) &&
          $body.hasClass("quickshop-popup-show"))
      ) {
        alert(window.cartStrings.addProductOutQuantity),
          $target.removeClass("is-loading");
        return;
      }
      const addItemToCart = (variantId) => {
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            if (
              ($body.hasClass("quickshop-popup-show") &&
                $body.removeClass("quickshop-popup-show"),
              $body.hasClass("quick-view-show"))
            )
              window.after_add_to_cart.type == "cart"
                ? halo.redirectTo(window.routes.cart)
                : Shopify.getCart((cartTotal) => {
                    $body.find("[data-cart-count]").text(cartTotal.item_count),
                      $target.removeClass("is-loading");
                  });
            else
              switch (window.after_add_to_cart.type) {
                case "cart":
                  halo.redirectTo(window.routes.cart);
                  break;
                case "quick_cart":
                  window.quick_cart.show
                    ? Shopify.getCart((cart) => {
                        window.quick_cart.type == "popup" ||
                          ($body.addClass("cart-sidebar-show"),
                          halo.updateSidebarCart(cart)),
                          $target.removeClass("is-loading");
                      })
                    : halo.redirectTo(window.routes.cart);
                  break;
                case "popup_cart_1":
                  Shopify.getCart((cart) => {
                    halo.updatePopupCart(cart, 1, variantId),
                      halo.updateSidebarCart(cart),
                      $body.addClass("add-to-cart-show"),
                      $target.removeClass("is-loading");
                  });
                  break;
              }
          });
      };
      fetch(window.Shopify.routes.root + "cart.js", { method: "GET" })
        .then((response) => response.json())
        .then((response) => {
          const variantId = parseInt(
              $(addToCartForm).serialize().split("id=")[1]
            ),
            item = response.items.find(
              (item2) => item2.variant_id == variantId
            ),
            currentQuantity = item?.quantity,
            currentProductId = item?.product_id,
            moreQuantity = parseInt(
              productForm.find("[data-inventory-quantity]").val()
            ),
            maxQuantity = parseInt(
              productForm
                .find("[data-inventory-quantity]")
                .data("inventory-quantity")
            ),
            saleOutStock =
              (document.getElementById("product-add-to-cart").dataset
                .available ===
                "true") |
              !1;
          if (!currentQuantity || !maxQuantity || saleOutStock)
            return addItemToCart(variantId);
          var arrayInVarName = `selling_array_${currentProductId}`,
            itemInArray = window[arrayInVarName],
            itemStatus = itemInArray[variantId];
          if (itemStatus == "deny")
            if (currentQuantity + moreQuantity > maxQuantity)
              if (maxQuantity < 0) addItemToCart(variantId);
              else {
                const remainingQuantity = maxQuantity - currentQuantity;
                throw new Error(
                  `You ${
                    remainingQuantity > 0
                      ? `can only add ${remainingQuantity}`
                      : "cannot add"
                  } more of the items into the cart`
                );
              }
            else addItemToCart(variantId);
          else addItemToCart(variantId);
        })
        .catch((err) => {
          this.showWarning(err);
        })
        .finally(() => {
          $target.removeClass("is-loading");
        });
    },
    checkSufficientStock: function (productForm) {
      const maxValidQuantity = productForm
          .find("[data-inventory-quantity]")
          .data("inventory-quantity"),
        inputQuantity = parseInt(
          productForm.find("[data-inventory-quantity]").val()
        );
      return maxValidQuantity >= inputQuantity;
    },
    updateContentQuickshopOption3: function (handle) {
      var quickShopPopup = $("#halo-quickshop-popup-option-3"),
        quickShopPopupContent = quickShopPopup.find(".halo-popup-content");
      $.ajax({
        type: "get",
        url:
          window.routes.root + "/products/" + handle + "?view=ajax_quick_shop",
        beforeSend: function () {
          $("[data-quick-view-popup] .halo-popup-content").empty();
        },
        success: function (data) {
          quickShopPopupContent.html(data);
        },
        error: function (xhr, text) {
          halo.showWarning($.parseJSON(xhr.responseText).description);
        },
        complete: function () {
          var $scope = quickShopPopup.find(".quickshop");
          halo.productImageGallery($scope),
            setTimeout(() => {
              $body.addClass("quickshop-popup-show");
            }, 150);
        },
      });
    },
    appendProductQuickShopOption2: function (product) {
      if (window.innerWidth <= 767) {
        var quickshopMobilePopup = $doc.find("#halo-card-mobile-popup"),
          quickshopForm = product.clone();
        quickshopMobilePopup.find(".halo-popup-content").empty(),
          quickshopForm.find(".card-product__group").remove(),
          quickshopMobilePopup
            .find(".halo-popup-content")
            .append(quickshopForm);
        var form = quickshopMobilePopup.find("[data-quickshop] form").eq("0"),
          mobilePopupId = form.attr("id") + "mobile";
        form.attr("id", mobilePopupId);
        var optionInputs = form.find(".single-option"),
          optionLabels = form.find(".single-label");
        optionInputs.each((index2, optionInput) => {
          $(optionInput).attr("id", $(optionInput).attr("id") + "-mobile");
        }),
          optionLabels.each((index2, optionLabel) => {
            $(optionLabel).attr("for", $(optionLabel).attr("for") + "-mobile");
          }),
          quickshopMobilePopup.addClass("show"),
          $doc.on("click", (e) => {
            var $target = $(e.target);
            $target.hasClass("background-overlay") &&
              (quickshopMobilePopup.removeClass("show"),
              $body.removeClass("quick_shop_popup_mobile"),
              product.removeClass("quickshop-popup-show"));
          });
      }
    },
    isRunningInIframe: function () {
      try {
        return window.self !== window.top;
      } catch {
        return !0;
      }
    },
    redirectTo: function (url) {
      halo.isRunningInIframe() && !window.iframeSdk
        ? (window.top.location = url)
        : (window.location = url);
    },
    initQuickCart: function () {
      window.quick_cart.show &&
        (window.quick_cart.type == "popup" || halo.initSidebarCart()),
        halo.initEventQuickCart();
    },
    initEventQuickCart: function () {
      halo.removeItemQuickCart(),
        halo.updateQuantityItemQuickCart(),
        halo.editQuickCart();
    },
    productCollectionCartSlider: function () {
      var productCart = $("[data-product-collection-cart]");
      productCart.each((index2, element) => {
        var self = $(element),
          productGrid = self.find(".products-carousel"),
          itemDots = productGrid.data("item-dots"),
          itemArrows = productGrid.data("item-arrows");
        productGrid.length > 0 &&
          (productGrid.hasClass("slick-initialized") ||
            productGrid.slick({
              mobileFirst: !0,
              adaptiveHeight: !1,
              infinite: !1,
              vertical: !1,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: !0,
              arrows: !1,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 1025,
                  settings: { dots: itemDots, arrows: itemArrows },
                },
              ],
            }));
      });
    },
    updatePopupCart: function (cart, layout, variantId) {
      var item = cart.items.filter((item2) => item2.id == variantId)[0],
        popup = $("[data-add-to-cart-popup]"),
        product = popup.find(".product-added"),
        productTitle = product.find(".product-title"),
        productImage = product.find(".product-image"),
        title = item.title || item.product_title,
        image = item.featured_image,
        img =
          '<img src="' +
          image.url +
          '" alt="' +
          image.alt +
          '" title="' +
          image.alt +
          '"/>';
      productImage.attr("href", item.url).html(img),
        productTitle
          .find(".title")
          .attr("href", item.url)
          .empty()
          .append(title),
        Shopify.getCart((cartTotal) => {
          $body.find("[data-cart-count]").text(cartTotal.item_count);
        });
    },
    initSidebarCart: function () {
      var cartIcon = $("[data-cart-sidebar]");
      let checkInitSideBarCart = !0;
      cartIcon.on("click", () => {
        checkInitSideBarCart &&
          ((checkInitSideBarCart = !1),
          Shopify.getCart((cart) => {
            halo.updateSidebarCart(cart);
          }));
      }),
        $body.hasClass("template-cart")
          ? cartIcon.on("click", (event2) => {
              event2.preventDefault(),
                event2.stopPropagation(),
                $("html, body").animate({ scrollTop: 0 }, 700);
            })
          : cartIcon.on("click", (event2) => {
              event2.preventDefault(),
                event2.stopPropagation(),
                $body.addClass("cart-sidebar-show");
            }),
        $doc.on("click", "[data-close-cart-sidebar]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.hasClass("cart-sidebar-show") &&
              $body.removeClass("cart-sidebar-show");
        }),
        $body.on("click", ".background-overlay", (event2) => {
          $body.hasClass("cart-sidebar-show") &&
            !$body.hasClass("edit-cart-show") &&
            !$body.hasClass("term-condition-show") &&
            !$body.hasClass("has-warning") &&
            $(event2.target).closest("#halo-cart-sidebar").length === 0 &&
            $(event2.target).closest("[data-cart-sidebar]").length === 0 &&
            $(event2.target).closest("[data-edit-cart-popup]").length === 0 &&
            $(event2.target).closest("[data-warning-popup]").length === 0 &&
            $(event2.target).closest("[data-term-condition-popup]").length ===
              0 &&
            $body.removeClass("cart-sidebar-show");
        });
    },
    updateSidebarCart: function (cart) {
      if (!$.isEmptyObject(cart)) {
        const $cartDropdown = $(
            "#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper"
          ),
          $cartLoading =
            '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
          loadingClass = "is-loading";
        $cartDropdown.addClass(loadingClass).prepend($cartLoading),
          $.ajax({
            type: "GET",
            url: window.routes.root + "/cart?view=ajax_side_cart",
            cache: !1,
            success: function (data) {
              var response = $(data);
              $cartDropdown.removeClass(loadingClass).html(response),
                halo.dispatchChangeForShippingMessage();
            },
            error: function (xhr, text) {
              halo.showWarning($.parseJSON(xhr.responseText).description);
            },
            complete: function () {
              $body.find("[data-cart-count]").text(cart.item_count),
                halo.productCollectionCartSlider(),
                halo.updateGiftWrapper(),
                halo.checkNeedToConvertCurrency() &&
                  Currency.convertAll(
                    window.shop_currency,
                    $("#currencies .active").attr("data-currency"),
                    "span.money",
                    "money_format"
                  ),
                document.dispatchEvent(
                  new CustomEvent("cart-update", { detail: cart })
                );
            },
          });
      }
    },
    dispatchChangeForShippingMessage: function () {
      document
        .querySelectorAll("[data-free-shipping-wrapper]")
        .forEach((freeShippingWrapper) => {
          const changeEvent = new Event("change", { bubbles: !0 });
          freeShippingWrapper.dispatchEvent(changeEvent);
        });
    },
    updateGiftWrapper: function () {
      let debounce;
      $("#gift-wrapping")
        .off("click")
        .on("click", (event2) => {
          event2.stopPropagation(), event2.preventDefault();
          const $target = $(event2.currentTarget);
          clearTimeout(debounce),
            (debounce = setTimeout(() => {
              const variantId = event2.target.dataset.giftId;
              Shopify.addItem(variantId, 1, $target, () => {
                Shopify.getCart((cart) => {
                  halo.updateSidebarCart(cart);
                });
              });
            }, 250));
        }),
        $("#cart-gift-wrapping")
          .off("click")
          .on("click", (event2) => {
            event2.stopPropagation(), event2.preventDefault();
            var $target = $(event2.currentTarget),
              text = $target.attr("data-adding-text");
            $target.text(text),
              clearTimeout(debounce),
              (debounce = setTimeout(() => {
                const variantId = event2.target.dataset.giftId;
                Shopify.addItem(variantId, 1, $target, () => {
                  Shopify.getCart((cart) => {
                    halo.updateCart(cart);
                  });
                });
              }, 250));
          });
    },
    removeItemQuickCart: function () {
      $doc.on("click", "[data-cart-remove]", (event2) => {
        event2.preventDefault(), event2.stopPropagation();
        var $target = $(event2.currentTarget),
          productId = $target.attr("data-cart-remove-id"),
          text = $("#cart-gift-wrapping").attr("data-add-text"),
          productLine2 = $target.data("line");
        $("#cart-gift-wrapping").text(text),
          Shopify.removeItem(productLine2, (cart) => {
            $body.hasClass("template-cart")
              ? halo.updateCart(cart)
              : $body.hasClass("cart-modal-show") ||
                ($body.hasClass("cart-sidebar-show") &&
                  halo.updateSidebarCart(cart));
          });
      });
    },
    updateCart: function (cart) {
      if (!$.isEmptyObject(cart)) {
        const $sectionId = $("#main-cart-items").data("id"),
          $cart = $("[data-cart]"),
          $cartContent = $cart.find("[data-cart-content]"),
          $cartTotals = $cart.find("[data-cart-total]"),
          $cartLoading =
            '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
          loadingClass = "is-loading";
        $cart.addClass(loadingClass).prepend($cartLoading),
          $.ajax({
            type: "GET",
            url: `/cart?section_id=${$sectionId}`,
            cache: !1,
            success: function (data) {
              var jsPreventedData = data.replaceAll(
                  "cart-coupon-discount",
                  "div"
                ),
                response = $(jsPreventedData);
              if (
                ($cart.removeClass(loadingClass),
                $cart.find(".loading-overlay").remove(),
                cart.item_count > 0)
              ) {
                var contentCart = response
                    .find("[data-cart-content] .cart")
                    .html(),
                  subTotal = response
                    .find("[data-cart-total] .cart-total-subtotal")
                    .html(),
                  grandTotal = response
                    .find("[data-cart-total] .cart-total-grandtotal")
                    .html(),
                  savings = response
                    .find("[data-cart-total] .cart-total-savings")
                    .html();
                if (
                  ($cartContent.find(".cart").html(contentCart),
                  $cartTotals.find(".cart-total-subtotal").html(subTotal),
                  $cartTotals.find(".cart-total-grandtotal").html(grandTotal),
                  $cartTotals.find(".cart-total-savings").html(savings),
                  response.find(".haloCalculatorShipping").length > 0)
                ) {
                  var calculatorShipping = response.find(
                    ".haloCalculatorShipping"
                  );
                  $cart
                    .find(".haloCalculatorShipping")
                    .replaceWith(calculatorShipping);
                }
              } else {
                var contentCart = response.find("#main-cart-items").html(),
                  headerCart = response.find(".page-header").html();
                (cartCountdownText1 = response
                  .find(".cart-countdown")
                  .data("coundown-text-empty-1")),
                  (cartCountdownText2 = response
                    .find(".cart-countdown")
                    .data("coundown-text-empty-2")),
                  (cartCountdownProductUrl = response
                    .find(".cart-countdown")
                    .data("coundown-prd-empty-url")),
                  (cartCountdownProductTitle = response
                    .find(".cart-countdown")
                    .data("coundown-prd-empty-title"));
                var cartCountdownHtml =
                  cartCountdownText1 +
                  ' <a href="' +
                  cartCountdownProductUrl +
                  '" class="cart-countdown-product link-effect p-relative"><span class="text">' +
                  cartCountdownProductTitle +
                  "</span></a> " +
                  cartCountdownText2;
                $("#main-cart-items").html(contentCart),
                  $(".page-header").html(headerCart),
                  $(".cart-countdown .text-wrap").html(cartCountdownHtml);
              }
            },
            error: function (xhr, text) {
              halo.showWarning($.parseJSON(xhr.responseText).description);
            },
            complete: function () {
              if (
                ($body.find("[data-cart-count]").text(cart.item_count),
                halo.dispatchChangeForShippingMessage(),
                halo.checkNeedToConvertCurrency() &&
                  Currency.convertAll(
                    window.shop_currency,
                    $("#currencies .active").attr("data-currency"),
                    "span.money",
                    "money_format"
                  ),
                $body.hasClass("template-cart"))
              ) {
                const giftWrapping =
                    document.getElementById("cart-gift-wrapping"),
                  isChecked = giftWrapping?.dataset.isChecked,
                  variantId = giftWrapping?.dataset.giftId;
                if (isChecked === "true") {
                  $("#is-a-gift").hide();
                  const giftCardRemoveButton = document.querySelector(
                      `[data-cart-remove-id="${variantId}"]`
                    ),
                    giftCardQuantityInput = document.querySelector(
                      `[data-cart-quantity-id="${variantId}"]`
                    );
                  giftCardRemoveButton?.addEventListener("click", () => {
                    giftWrapping.dataset.isChecked = "false";
                  }),
                    giftCardQuantityInput?.addEventListener("change", (e) => {
                      Number(e.target.value) <= 0 &&
                        (giftWrapping.dataset.isChecked = "false");
                    });
                } else $("#is-a-gift").show();
              }
              document.dispatchEvent(
                new CustomEvent("cart-update", { detail: cart })
              );
            },
          });
      }
    },
    updateQuantityItemQuickCart: function () {
      $doc.on("change", "[data-cart-quantity]", (event2) => {
        event2.preventDefault(), event2.stopPropagation();
        var $target = $(event2.currentTarget),
          productId = $target.attr("data-cart-quantity-id"),
          productLine2 = $target.data("line"),
          quantity = parseInt($target.val()),
          stock = parseInt($target.data("inventory-quantity"));
        let enoughInStock = !0;
        if (stock < quantity && stock > 0) {
          var arrayInVarName = `cart_selling_array_${
              event2.currentTarget.closest("cart-update-quantity").dataset
                .product
            }`,
            itemInArray = window[arrayInVarName],
            itemStatus =
              itemInArray[
                event2.currentTarget.closest("cart-update-quantity").dataset
                  .variant
              ];
          itemStatus == "deny" && ((quantity = stock), (enoughInStock = !1));
        }
        Shopify.changeItem(productLine2, quantity, (cart) => {
          $body.hasClass("template-cart")
            ? halo.updateCart(cart)
            : $body.hasClass("cart-modal-show") ||
              ($body.hasClass("cart-sidebar-show") &&
                halo.updateSidebarCart(cart)),
            enoughInStock ||
              halo.showWarning(
                `${window.cartStrings.addProductOutQuantity.replace(
                  "[maxQuantity]",
                  quantity
                )}`
              );
        });
      });
    },
    editQuickCart: function () {
      let checkLoadEC = !0;
      $doc.on("click", "[data-open-edit-cart]", (event2) => {
        event2.preventDefault(), event2.stopPropagation();
        var $target = $(event2.currentTarget),
          url = $target.data("edit-cart-url"),
          itemId = $target.data("edit-cart-id"),
          itemLine = $target.data("line"),
          quantity = $target.data("edit-cart-quantity"),
          option = $target
            .parents(".previewCartItem")
            .find("previewCartItem-variant")
            .text();
        const modal = $("[data-edit-cart-popup]"),
          modalContent = modal.find(".halo-popup-content");
        if (checkLoadEC) {
          checkLoadEC = !1;
          const $editCart = document.querySelector(".halo-edit-cart-popup"),
            urlStyleEC = $editCart.dataset.urlStyleEditCart,
            urlScriptEC = $editCart.dataset.urlScriptEditCart;
          halo.buildStyleSheet(urlStyleEC, $editCart),
            halo.buildScript(urlScriptEC);
        }
        $.ajax({
          type: "get",
          url,
          cache: !1,
          dataType: "html",
          beforeSend: function () {
            $body.hasClass("template-cart");
          },
          success: function (data) {
            modalContent.html(data),
              modalContent
                .find("[data-template-cart-edit]")
                .attr({ "data-cart-update-id": itemId, "data-line": itemLine });
            var productItem = modalContent.find(".product-edit-item");
            productItem.find('input[name="quantity"]').val(quantity);
          },
          error: function (xhr, text) {
            halo.showWarning($.parseJSON(xhr.responseText).description),
              $body.hasClass("template-cart");
          },
          complete: function () {
            $body.addClass("edit-cart-show"),
              $body.hasClass("template-cart"),
              halo.checkNeedToConvertCurrency() &&
                Currency.convertAll(
                  window.shop_currency,
                  $("#currencies .active").attr("data-currency"),
                  "span.money",
                  "money_format"
                );
          },
        });
      }),
        $doc.on("click", "[data-close-edit-cart]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.removeClass("edit-cart-show");
        }),
        $doc.on("click", (event2) => {
          $body.hasClass("edit-cart-show") &&
            $(event2.target).closest("[data-edit-cart-popup]").length === 0 &&
            $(event2.target).closest("[data-open-edit-cart]").length === 0 &&
            $body.removeClass("edit-cart-show");
        }),
        halo.addMoreItemEditCart(),
        halo.addAllItemCartEdit();
    },
    addMoreItemEditCart: function () {
      $doc.on("click", "[data-edit-cart-add-more]", (event2) => {
        event2.preventDefault(), event2.stopPropagation();
        var itemWrapper = $("[data-template-cart-edit]"),
          currentItem = $(event2.target).parents(".product-edit-item"),
          count = parseInt(itemWrapper.attr("data-count")),
          cloneProduct = currentItem
            .clone()
            .removeClass("product-edit-itemFirst");
        (cloneProductId = cloneProduct.attr("id") + count),
          cloneProduct.attr("id", cloneProductId),
          console.log(cloneProductId),
          halo.updateClonedProductAttributes(cloneProduct, count),
          cloneProduct.insertAfter(currentItem),
          (count = count + 1),
          itemWrapper.attr("data-count", count);
      }),
        $doc.on("click", "[data-edit-cart-remove]", (event2) => {
          event2.preventDefault(), event2.stopPropagation();
          var currentItem = $(event2.target).parents(".product-edit-item");
          currentItem.remove();
        });
    },
    updateClonedProductAttributes: function (product, count) {
      var form = $(".shopify-product-form", product),
        formId = form.attr("id"),
        newFormId = formId + count;
      form.attr("id", newFormId),
        $(".product-form__radio", product).each((index2, element) => {
          var formInput = $(element),
            formLabel = formInput.next(),
            id = formLabel.attr("for"),
            newId = id + count,
            formInputName = formInput.attr("name");
          formLabel.attr("for", newId),
            formInput.attr({ id: newId, name: formInputName + count });
        });
    },
    addAllItemCartEdit: function () {
      $doc.on("click", "#add-all-to-cart", (event2) => {
        event2.preventDefault(), event2.stopPropagation();
        var $target = $(event2.currentTarget),
          cartEdit = $("[data-template-cart-edit]"),
          product = cartEdit.find(".product-edit-item.isChecked"),
          productId = cartEdit.attr("data-cart-update-id");
        (productLine = cartEdit.data("line")),
          product.length > 0
            ? ($target.addClass("is-loading"),
              Shopify.removeItem(productLine, (cart) => {
                if (!$.isEmptyObject(cart)) {
                  var productHandleQueue = [],
                    ajax_caller = function (data) {
                      return $.ajax(data);
                    };
                  product.each((index2, element) => {
                    var item = $(element),
                      variantId = item.find('input[name="id"]').val(),
                      qty = parseInt(item.find('input[name="quantity"]').val());
                    productHandleQueue.push(
                      ajax_caller({
                        type: "post",
                        url: window.routes.root + "/cart/add.js",
                        data: "quantity=" + qty + "&id=" + variantId,
                        dataType: "json",
                        async: !1,
                      })
                    );
                  }),
                    productHandleQueue.length > 0 &&
                      $.when.apply($, productHandleQueue).done((event3) => {
                        setTimeout(function () {
                          $target.removeClass("is-loading");
                        }, 1e3),
                          Shopify.getCart((cart2) => {
                            $body.removeClass("edit-cart-show"),
                              $body.hasClass("template-cart")
                                ? halo.updateCart(cart2)
                                : $body.hasClass("cart-modal-show") ||
                                  ($body.hasClass("cart-sidebar-show") &&
                                    halo.updateSidebarCart(cart2));
                          });
                      });
                }
              }))
            : alert(window.variantStrings.addToCart_message);
      });
    },
    initNotifyInStock: function () {
      $doc.on("click", "[data-open-notify-popup]", (event2) => {
        event2.preventDefault(), event2.stopPropagation();
        var $target = $(event2.currentTarget);
        halo.notifyInStockPopup($target);
      }),
        $doc.on("click", "[data-close-notify-popup]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.removeClass("notify-me-show"),
            setTimeout(() => {
              $(".halo-notify-popup .form-field").removeClass("hidden"),
                $(".halo-notify-popup .form-message").addClass("hidden");
            }, 700);
        }),
        $doc.on("click", (event2) => {
          $body.hasClass("notify-me-show") &&
            $(event2.target).closest("[data-open-notify-popup]").length === 0 &&
            $(event2.target).closest("[data-notify-popup]").length === 0 &&
            ($body.removeClass("notify-me-show"),
            setTimeout(() => {
              $(".halo-notify-popup .form-field").removeClass("hidden"),
                $(".halo-notify-popup .form-message").addClass("hidden");
            }, 700));
        });
    },
    notifyInStockPopup: function ($target) {
      var variant,
        product = $target.parents(".product-item"),
        title = product.find(".card-title").data("product-title"),
        link =
          window.location.host +
          product.find(".card-title").data("product-url"),
        popup = $("[data-notify-popup]");
      $target.hasClass("is-notify-me")
        ? (variant = product
            .find(".card-swatch .swatch-label.is-active")
            .attr("title"))
        : (variant = $target.data("variant-id")),
        popup.find(".halo-notify-product-title").val($.trim(title)),
        popup.find(".halo-notify-product-link").val(link),
        variant && popup.find(".halo-notify-product-variant").val(variant),
        $body.addClass("notify-me-show");
    },
    initAskAnExpert: function () {
      $doc.on("click", "[data-open-ask-an-expert]", (event2) => {
        event2.preventDefault(), event2.stopPropagation();
        var askAnExpert = $("[data-ask-an-expert-popup]"),
          modalContent = askAnExpert.find(".halo-popup-content"),
          url;
        if ($body.hasClass("template-product")) {
          var handle = $(".productView").data("product-handle");
          url =
            window.routes.root +
            "/products/" +
            handle +
            "?view=ajax_ask_an_expert";
        } else if ($body.hasClass("quick-view-show")) {
          var handle = $(".halo-quickView").data("product-quickview-handle");
          url =
            window.routes.root +
            "/products/" +
            handle +
            "?view=ajax_ask_an_expert";
        } else url = window.routes.root + "/search?view=ajax_ask_an_expert";
        $.ajax({
          type: "get",
          url,
          beforeSend: function () {
            modalContent.empty();
          },
          success: function (data) {
            modalContent.html(data);
          },
          error: function (xhr, text) {
            alert($.parseJSON(xhr.responseText).description);
          },
          complete: function () {
            $body.addClass("ask-an-expert-show");
          },
        });
      }),
        $doc.on("click", "[data-close-ask-an-expert]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.removeClass("ask-an-expert-show"),
            $body.hasClass("recently-popup-mb-show") &&
              $body.removeClass("recently-popup-mb-show");
        }),
        $doc.on("click", (event2) => {
          $body.hasClass("ask-an-expert-show") &&
            $(event2.target).closest("[data-open-ask-an-expert]").length ===
              0 &&
            $(event2.target).closest("#halo-ask-an-expert-popup").length ===
              0 &&
            $body.removeClass("ask-an-expert-show");
        });
    },
    resetForm: function (form) {
      $(".form-field", form).removeClass(
        "form-field--success form-field--error"
      ),
        $("input[type=email], input[type=text], textarea", form).val("");
    },
    formMessage: function () {
      const error = window.location.href.indexOf("form_type=contact") > -1;
      if (window.location.href.indexOf("contact_posted=true") > -1 || error) {
        const formMessage = $(
          `[data-form-message="${$.cookie("contact_form")}"]`
        );
        let delay = 400;
        switch (
          ($body.hasClass("template-product") && (delay = 1600),
          formMessage.data("form-message"))
        ) {
          case "ask":
            setTimeout(() => {
              $body.addClass("ask-an-expert-show");
            }, delay),
              this.changeStateforContactForm(formMessage, error),
              $(".halo-notify-popup .form-message").addClass("hidden");
            break;
          case "contact":
            formMessage.removeClass("hidden"),
              this.changeStateforContactForm(formMessage, error),
              $(".halo-notify-popup .form-message").addClass("hidden");
            break;
          case "notifyMe":
            $(".halo-notify-popup .form-field").addClass("hidden"),
              setTimeout(() => {
                $body.addClass("notify-me-show");
              }, delay),
              this.changeStateforContactForm(formMessage, error);
            break;
        }
      }
      $(document).on("click", "[data-button-message]", (event2) => {
        $.cookie("contact_form", $(event2.target).data("button-message"), {
          expires: 1,
          path: "/",
        });
      });
    },
    changeStateforContactForm(formMessage, error) {
      window.history.pushState(
        "object",
        document.title,
        location.href.split("?")[0]
      ),
        error &&
          ($(".newsletter-form__message--error").addClass("hidden"),
          $("html, body").animate(
            { scrollTop: formMessage.offset().top - window.innerHeight / 2 },
            700
          ));
    },
    initCompareProduct: function () {
      var $compareLink = $("[data-compare-link]");
      window.compare.show &&
        (halo.setLocalStorageProductForCompare($compareLink),
        halo.setAddorRemoveProductForCompare($compareLink),
        halo.setProductForCompare(),
        $doc.on("click", "[data-close-compare-product-popup]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.removeClass("compare-product-show");
        }),
        $doc.on("click", (event2) => {
          $body.hasClass("compare-product-show") &&
            $(event2.target).closest("[data-compare-link]").length === 0 &&
            $(event2.target).closest("[data-compare-product-popup]").length ===
              0 &&
            $body.removeClass("compare-product-show");
        }));
    },
    setLocalStorageProductForCompare: function ($link) {
      var count = JSON.parse(localStorage.getItem("compareItem")),
        items = $("[data-product-compare-handle]");
      count !== null &&
        items.length > 0 &&
        (items.each((index2, element) => {
          var item = $(element),
            handle = item.data("product-compare-handle");
          count.indexOf(handle) >= 0
            ? (item.find(".compare-icon").addClass("is-checked"),
              item.find(".text").text(window.compare.added),
              item.find("input").prop("checked", !0))
            : (item.find(".compare-icon").removeClass("is-checked"),
              item.find(".text").text(window.compare.add),
              item.find("input").prop("checked", !1));
        }),
        halo.updateCounterCompare($link));
    },
    setAddorRemoveProductForCompare: function ($link) {
      $doc.on("change", "[data-product-compare] input", (event2) => {
        var $this = $(event2.currentTarget),
          item = $this.parents(".card-compare"),
          handle = $this.val(),
          count = JSON.parse(localStorage.getItem("compareItem"));
        (count = halo.uniqueArray(count)),
          event2.currentTarget.checked
            ? (item.find(".compare-icon").addClass("is-checked"),
              item.find(".text").text(window.compare.added),
              item.find("input").prop("checked", !0),
              halo.incrementCounterCompare(count, handle, $link))
            : (item.find(".compare-icon").removeClass("is-checked"),
              item.find(".text").text(window.compare.add),
              item.find("input").prop("checked", !1),
              halo.decrementCounterCompare(count, handle, $link));
      });
    },
    setProductForCompare: function () {
      $doc.on("click", "[data-compare-link]", (event2) => {
        event2.preventDefault(), event2.stopPropagation();
        var list = JSON.parse(localStorage.getItem("compareItem"));
        if (list.length <= 1) return alert(window.compare.message), !1;
        halo.updateContentCompareProduct(list, 0);
      }),
        $doc.on("click", "[data-compare-remove]", (event2) => {
          event2.preventDefault(), event2.stopPropagation();
          var id = $(event2.currentTarget).data("compare-item"),
            compareTable = $("[data-compare-product-popup] .compareTable"),
            item = compareTable.find(
              '.compareTable-row[data-product-compare-id="' + id + '"]'
            ),
            handle = item.data("compare-product-handle");
          if (compareTable.find("tbody .compareTable-row").length == 1) {
            item.remove();
            var count = JSON.parse(localStorage.getItem("compareItem")),
              index2 = count.indexOf(handle),
              $compareLink = $("[data-compare-link]");
            index2 > -1 &&
              (count.splice(index2, 1),
              (count = halo.uniqueArray(count)),
              localStorage.setItem("compareItem", JSON.stringify(count)),
              halo.setLocalStorageProductForCompare($compareLink),
              halo.updateCounterCompare($compareLink)),
              $body.removeClass("compare-product-show");
          } else {
            item.remove();
            var count = JSON.parse(localStorage.getItem("compareItem")),
              index2 = count.indexOf(handle),
              $compareLink = $("[data-compare-link]");
            index2 > -1 &&
              (count.splice(index2, 1),
              (count = halo.uniqueArray(count)),
              localStorage.setItem("compareItem", JSON.stringify(count)),
              halo.setLocalStorageProductForCompare($compareLink),
              halo.updateCounterCompare($compareLink));
          }
        });
    },
    updateCounterCompare: function ($link) {
      var count = JSON.parse(localStorage.getItem("compareItem"));
      count.length > 1
        ? ($link.parent().addClass("is-show"),
          $link.find("span.countPill").html(count.length))
        : $link.parent().removeClass("is-show");
    },
    uniqueArray: function (list) {
      var result = [];
      return (
        $.each(list, function (index2, element) {
          $.inArray(element, result) == -1 && result.push(element);
        }),
        result
      );
    },
    incrementCounterCompare: function (count, item, $link) {
      const index2 = count.indexOf(item);
      count.push(item),
        (count = halo.uniqueArray(count)),
        localStorage.setItem("compareItem", JSON.stringify(count)),
        halo.updateCounterCompare($link);
    },
    decrementCounterCompare: function (count, item, $link) {
      const index2 = count.indexOf(item);
      index2 > -1 &&
        (count.splice(index2, 1),
        (count = halo.uniqueArray(count)),
        localStorage.setItem("compareItem", JSON.stringify(count)),
        halo.updateCounterCompare($link));
    },
    updateContentCompareProduct: function (list, count) {
      const compareTable = $("[data-compare-product-popup] .compareTable"),
        url =
          window.routes.root +
          "/products/" +
          list[count] +
          "?view=ajax_product_card_compare";
      count == 0 && compareTable.find("tbody").empty(),
        list.length > count
          ? $.ajax({
              type: "get",
              url,
              cache: !1,
              success: function (data) {
                compareTable.find("tbody").append(data),
                  count++,
                  halo.updateContentCompareProduct(list, count);
              },
            })
          : $body.addClass("compare-product-show");
    },
    initProductView: function ($scope) {
      halo.productImageGallery($scope),
        halo.productLastSoldOut($scope),
        halo.productCustomerViewing($scope),
        halo.productCountdown($scope),
        halo.productSizeChart($scope),
        halo.productCustomCursor($scope),
        halo.productVideoGallery($scope),
        halo.initVariantImageGroup($scope, window.variant_image_group);
    },
    initQuickView: function () {
      let checkLoadQV = !0;
      $doc.on("click", "[data-open-quick-view-popup]", (event2) => {
        if ((event2.preventDefault(), event2.stopPropagation(), checkLoadQV)) {
          checkLoadQV = !1;
          const $quickView = document.querySelector(".halo-quick-view-popup"),
            urlStyleProduct = $quickView.dataset.urlStyleProduct,
            urlStyleQV = $quickView.dataset.urlStyleQuickView,
            urlVariantsQV = $quickView.dataset.urlVariantsQuickView,
            urlSortable =
              "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js";
          document.body.matches(".qs3-loaded") ||
            halo.buildStyleSheet(urlStyleProduct, $quickView),
            halo.buildStyleSheet(urlStyleQV, $quickView),
            halo.buildScript(urlVariantsQV),
            document.body.classList.add("qv-loaded"),
            document.body.matches(".sortable-loader") ||
              (document.body.classList.add("sortable-loader"),
              halo.buildScript(urlSortable));
        }
        var handle = $(event2.currentTarget).data("product-handle");
        halo.updateContentQuickView(handle);
      }),
        $doc.on("click", "[data-close-quick-view-popup]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.removeClass("quick-view-show");
        }),
        $(".background-overlay")
          .off("click.closeQuickView")
          .on("click.closeQuickView", (e) => {
            $body.hasClass("quick-view-show") &&
              !$body.hasClass("cart-sidebar-show") &&
              !$body.hasClass("ask-an-expert-show") &&
              !$body.hasClass("size-chart-show") &&
              !$body.hasClass("compare-color-show") &&
              !$body.hasClass("term-condition-show") &&
              $body.removeClass("quick-view-show");
          });
    },
    updateContentQuickView: function (handle) {
      var popup = $("[data-quick-view-popup]"),
        popupContent = popup.find(".halo-popup-content");
      $.ajax({
        type: "get",
        url:
          window.routes.root + "/products/" + handle + "?view=ajax_quick_view",
        beforeSend: function () {
          popupContent.empty(),
            $("#halo-quickshop-popup-option-3")
              .find(".halo-popup-content")
              .empty();
        },
        success: function (data) {
          popupContent.html(data);
        },
        error: function (xhr, text) {
          alert($.parseJSON(xhr.responseText).description);
        },
        complete: function () {
          var $scope = popup.find(".quickView");
          const items = $(
              ".halo-popup-content .halo-compare-color-popup li.item"
            ),
            tableList = $(
              ".halo-popup-content .halo-compare-color-popup #sortTableList"
            ),
            compareColorPopup = $(
              ".halo-popup-content .halo-compare-color-popup"
            ),
            sizeChartPopup = $(".halo-popup-content .halo-size-chart-popup");
          if (
            (halo.productImageGallery($scope),
            halo.productLastSoldOut($scope),
            halo.productCustomerViewing($scope),
            halo.productCountdown($scope),
            halo.productSizeChart($scope),
            halo.setProductForWishlist(handle),
            halo.initVariantImageGroup(
              $scope,
              window.variant_image_group_quick_view
            ),
            $body.addClass("quick-view-show"),
            window.Shopify &&
              Shopify.PaymentButton &&
              Shopify.PaymentButton.init(),
            tableList.attr("id", "quickViewSortTableList"),
            items.each((index2, element) => {
              const itemInput = $(element).find(".swatch-compare-color-option"),
                itemLabel = $(element).find(".swatch-compare-color-label"),
                itemId = itemInput.attr("id");
              itemInput
                .attr("id", `quickView-${itemId}`)
                .attr("name", `quickView-${itemId}`),
                itemLabel.attr("for", `quickView-${itemId}`);
            }),
            compareColorPopup.attr("id", "quickView-halo-compare-color-popup"),
            sizeChartPopup.attr("id", "quickView-halo-size-chart-popup"),
            $(".halo-productView .addthis_inline_share_toolbox").length)
          ) {
            var html = $(
              ".halo-productView .addthis_inline_share_toolbox"
            ).html();
            $(".halo-popup-content .share-button__button").click(function () {
              $(".halo-popup-content .addthis_inline_share_toolbox").append(
                html
              );
            });
          }
          const thisSortTable = document.getElementById(
              "quickViewSortTableList"
            ),
            thisImageList = $(".halo-popup-content .halo-compareColors-image");
          window.innerWidth >= 1025 && thisSortTable
            ? new Sortable(thisSortTable, { animation: 150 })
            : onRemoveHandlerQuickView();
          function onRemoveHandlerQuickView() {
            thisImageList.on("click", ".item", (event2) => {
              event2.preventDefault();
              var $target = event2.currentTarget,
                itemId = $target.classList[1].replace("item-", ""),
                optionId = `swatch-compare-color-${itemId}`,
                item = $(document.getElementById(optionId));
              item.trigger("click");
            });
          }
          if (
            window.review.show_quick_view &&
            $(".shopify-product-reviews-badge").length > 0 &&
            window.SPR != null &&
            typeof window.SPR.registerCallbacks == "functions"
          )
            return (
              window.SPR.registerCallbacks(),
              window.SPR.initRatingHandler(),
              window.SPR.initDomEls(),
              window.SPR.loadProducts(),
              window.SPR.loadBadges()
            );
        },
      });
    },
    productImageGallery: function ($scope) {
      var sliderNav = $scope.find(".productView-nav"),
        sliderFor = $scope.find('.productView-for:not(".mobile")'),
        sliderForMobile = $scope.find(".productView-for.mobile");
      if (!sliderNav.hasClass("slick-initialized")) {
        const navArrowsDesk = sliderNav.data("arrows-desk"),
          navArrowsMobi = sliderNav.data("arrows-mobi"),
          navCounterMobi = sliderNav.data("counter-mobi"),
          navMediaCount = sliderNav.data("media-count"),
          thumbnailToShow = parseInt(sliderFor.data("max-thumbnail-to-show"));
        let checkNav, checkFor, navSlideCount;
        var appendTimeout;
        sliderNav.hasClass("productView-nav-gallery")
          ? (navSlideCount = Math.round(navMediaCount / 2))
          : (navSlideCount = navMediaCount),
          sliderNav.hasClass("productView-horizontal-tabs") &&
          navMediaCount == 2
            ? (navSlideCount = 1)
            : (navSlideCount = navMediaCount);
        const slickCounter =
          `<div class="slick-counter">
                    <span class="slick-counter--current">1</span>
                    <span aria-hidden="true">/</span>
                    <span class="slick-counter--total">` +
          navSlideCount +
          `</span>
                </div>`;
        if (
          (sliderNav.on("init", () => {
            window.innerWidth < 768 &&
              navCounterMobi &&
              variant_image_group == "false" &&
              (clearTimeout(appendTimeout),
              (appendTimeout = setTimeout(() => {
                sliderNav.append(slickCounter);
              }, 1e3)),
              sliderNav.on(
                "reInit afterChange",
                function (event2, slick, currentSlide, nextSlide) {
                  var i = (currentSlide || 0) + 1;
                  sliderNav.find(".slick-counter--current").text(i);
                }
              )),
              $(".product-default .productView-thumbnail").on(
                "click",
                function () {
                  const index2 = $(this).data("index");
                  sliderNav.slick("slickGoTo", index2 - 1);
                }
              );
          }),
          sliderNav.on("reInit", () => {
            clearTimeout(appendTimeout),
              (appendTimeout = setTimeout(() => {
                sliderNav.append(slickCounter);
              }, 1e3)),
              $(".product-default .productView-thumbnail").on(
                "click",
                function () {
                  const index2 = $(this).data("index");
                  sliderNav.slick("slickGoTo", index2 - 1);
                }
              );
          }),
          sliderNav.closest(".productView").is(".layout-4")
            ? (checkFor = !1)
            : (checkFor = sliderFor),
          sliderNav.hasClass("productView-nav-gallery"))
        ) {
          var sliderNav2 = $scope.find(
              ".productView-nav.productView-nav-gallery"
            ),
            length = sliderNav2.data("media-count"),
            show = 2,
            rows = 2;
          length == 1 && ((show = 1), (rows = 1)),
            length == 2 && ((show = 2), (rows = 1)),
            sliderNav2.slick({
              dots: !0,
              rows,
              arrows: navArrowsDesk,
              infinite: !0,
              slidesPerRow: 1,
              slidesToShow: show,
              focusOnSelect: !1,
              asNavFor: checkFor,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                { breakpoint: 767, settings: { arrows: navArrowsMobi } },
              ],
            });
        } else if (sliderNav.hasClass("productView-horizontal-tabs")) {
          var sliderNav2 = $scope.find(
              ".productView-nav.productView-horizontal-tabs"
            ),
            show = 2,
            rows = 1;
          sliderNav2.slick({
            dots: !0,
            rows,
            arrows: navArrowsDesk,
            infinite: !0,
            slidesPerRow: 1,
            slidesToShow: show,
            focusOnSelect: !1,
            asNavFor: checkFor,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            rtl: window.rtl_slick,
            responsive: [
              { breakpoint: 767, settings: { arrows: navArrowsMobi } },
            ],
          });
        } else
          !sliderNav.is(".style-2, .style-3") || window.innerWidth < 768
            ? (sliderNav.slick({
                fade: !0,
                dots: !1,
                arrows: navArrowsDesk,
                infinite: !0,
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                rtl: window.rtl_slick,
                responsive: [
                  { breakpoint: 768, settings: { arrows: navArrowsMobi } },
                ],
              }),
              (checkNav = sliderNav))
            : (checkNav = !1);
        if (
          ($scope.hasClass("layout-1") ||
            $scope.hasClass("layout-2") ||
            $scope.hasClass("layout-3"),
          sliderNav.find("[data-youtube]").length > 0)
        )
          if (typeof window.onYouTubeIframeAPIReady > "u") {
            window.onYouTubeIframeAPIReady = halo.initYoutubeCarousel.bind(
              window,
              sliderNav
            );
            const tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          } else halo.initYoutubeCarousel(sliderNav);
        sliderNav.find("[data-vimeo]").length > 0 &&
          (sliderNav.on("beforeChange", (event2, slick) => {
            var currentSlide, player, command;
            (currentSlide = $(slick.$slider).find(".slick-current")),
              (player = currentSlide.find("iframe").get(0)),
              (command = { method: "pause", value: "true" }),
              player?.contentWindow.postMessage(JSON.stringify(command), "*");
          }),
          sliderNav.on("afterChange", (event2, slick) => {
            var currentSlide, player, command;
            (currentSlide = $(slick.$slider).find(".slick-current")),
              (player = currentSlide.find("iframe").get(0)),
              (command = { method: "play", value: "true" }),
              player?.contentWindow.postMessage(JSON.stringify(command), "*");
          })),
          sliderNav.find("[data-mp4]").length > 0 &&
            (sliderNav.on("beforeChange", (event2, slick) => {
              var currentSlide, player;
              (currentSlide = $(slick.$slider).find(".slick-current")),
                (player = currentSlide.find("video").get(0)),
                player?.pause();
            }),
            sliderNav.on("afterChange", (event2, slick) => {
              var currentSlide, player;
              (currentSlide = $(slick.$slider).find(".slick-current")),
                (player = currentSlide.find("video").get(0)),
                player?.play();
            }));
      }
      var productFancybox = $scope.find("[data-fancybox]");
      if (
        (productFancybox.length > 0 &&
          productFancybox.fancybox({
            buttons: [
              "zoom",
              "share",
              "slideShow",
              "fullScreen",
              "thumbs",
              "close",
            ],
            loop: !0,
            thumbs: { autoStart: !0 },
          }),
        $body.hasClass("template-product"))
      ) {
        if ($scope.closest(".quickView").length) return;
        var productZoom = $scope.find("[data-zoom-image]");
        $win.width() > 1024 &&
          productZoom.each((index2, element) => {
            var $this = $(element);
            $win.width() > 1024
              ? $this.zoom({ url: $this.attr("data-zoom-image"), touch: !1 })
              : $this.trigger("zoom.destroy");
          });
      }
    },
    productVideoGallery: function ($scope) {
      const videoThumbnail = $scope.find("[data-video-thumbnail]"),
        videoThumbnailLen = videoThumbnail.length,
        productVideoLen = $(".productView-video").length;
      if (videoThumbnailLen) {
        const $imageWrapper = $scope.find(".productView-image-wrapper"),
          videoModal = $("[data-popup-video]"),
          sliderNav = $scope.find(".productView-nav");
        let offsetTop =
          $imageWrapper.offset().top + $imageWrapper.outerHeight();
        productVideoLen && $body.addClass("has-product-video"),
          $win.on("scroll", (event2) => {
            const $targetCur = $(event2.currentTarget),
              thisVideo = $scope.find(".slick-current .productView-video"),
              videoType = thisVideo.data("type"),
              videoUrl = thisVideo.data("video-url");
            if (videoUrl != null)
              if ($targetCur.scrollTop() > offsetTop) {
                if (!videoModal.is(".is-show")) {
                  const player = sliderNav
                      .find(".slick-slide.slick-active")
                      .data("youtube-player"),
                    dataTime = parseInt(player.getCurrentTime()),
                    videoContent = `<div class="fluid-width-video-wrapper" style="padding-top: 56.24999999999999%">
                                                    ${
                                                      videoType == "youtube"
                                                        ? `<iframe
                                                            id="player"
                                                            type="text/html"
                                                            width="100%"
                                                            frameborder="0"
                                                            webkitAllowFullScreen
                                                            mozallowfullscreen
                                                            allowFullScreen
                                                            src="https://www.youtube.com/embed/${videoUrl}?autoplay=1&mute=1&start=${dataTime}">
                                                        </iframe>`
                                                        : `<iframe 
                                                            src="https://player.vimeo.com/video/${videoUrl}?autoplay=1&mute=1" 
                                                            class="js-vimeo" 
                                                            allow="autoplay; 
                                                            encrypted-media" 
                                                            webkitallowfullscreen 
                                                            mozallowfullscreen 
                                                            allowfullscreen">
                                                        </iframe>`
                                                    }
                                                </div>`;
                  videoModal.addClass("is-show"),
                    videoModal.find(".halo-popup-content").html(videoContent),
                    $body.addClass("video-show product-video-show"),
                    player.pauseVideo();
                }
              } else {
                const player = sliderNav
                  .find(".slick-slide.slick-active")
                  .data("youtube-player");
                videoModal.removeClass("is-show"),
                  videoModal.find(".halo-popup-content").empty(),
                  $body.removeClass("video-show product-video-show"),
                  player.playVideo();
              }
          });
      }
    },
    initVariantImageGroup: function ($scope, enable = !1) {
      if (enable) {
        var inputChecked = $scope.find("[data-filter]:checked"),
          sliderFor = $scope.find(".productView-for"),
          sliderNav = $scope.find(".productView-nav");
        if (inputChecked.length > 0) {
          var className = inputChecked.data("filter");
          className !== void 0 &&
            (sliderNav.slick("slickUnfilter"),
            sliderFor.slick("slickUnfilter"),
            sliderNav.find(className).length &&
              sliderFor.find(className).length &&
              (sliderNav.slick("slickFilter", className).slick("refresh"),
              sliderFor.slick("slickFilter", className).slick("refresh")));
        }
        $doc.on("change", "input[data-filter]", (event2) => {
          var className2 = $(event2.currentTarget).data("filter");
          sliderNav.find(".slick-counter").remove(),
            sliderNav.slick("slickUnfilter"),
            sliderFor.slick("slickUnfilter"),
            className2 !== void 0 &&
              sliderNav.find(className2).length &&
              sliderFor.find(className2).length &&
              (sliderNav.slick("slickFilter", className2).slick("refresh"),
              sliderFor.slick("slickFilter", className2).slick("refresh"));
        });
      }
    },
    initYoutubeCarousel: function (slider) {
      // Load YouTube API if not already loaded
      if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Create callback function
        window.onYouTubeIframeAPIReady = () => {
          this.initYoutubeCarouselEvent(slider);
        };
      } else {
        // If API is already loaded, initialize directly
        this.initYoutubeCarouselEvent(slider);
      }
    },
    initYoutubeCarouselEvent: function (slick) {
      var $slick = $(slick),
        $videos = $slick.find("[data-youtube]");

      bindEvents(slick);

      function bindEvents() {
        $slick.hasClass("slick-initialized") &&
          onSlickImageInit($slick, $videos),
          $doc.on("init", $slick, onSlickImageInit),
          $doc.on("beforeChange", $slick, onSlickImageBeforeChange),
          $doc.on("afterChange", $slick, onSlickImageAfterChange);
      }

      function onPlayerReady(event) {
        console.log('Player Ready', event.target.getIframe())
        $(event.target.getIframe())
          .closest(".slick-slide")
          .data("youtube-player", event.target),
          setTimeout(function () {
            $(event.target.getIframe())
              .closest(".slick-slide")
              .hasClass("slick-active") &&
              ($slick.slick("slickPause"), event.target.playVideo());
          }, 200);
      }

      function onPlayerStateChange(event) {
        event.data === YT.PlayerState.PLAYING && $slick.slick("slickPause"),
          event.data === YT.PlayerState.ENDED && $slick.slick("slickNext");
      }

      function onSlickImageInit() {
        $videos.each((j, vid) => {
          const $vid = $(vid),
            id = `youtube_player_${Math.floor(Math.random() * 100)}`;
          $vid.attr("id", id);

          // Only create player if YT is defined
          if (typeof YT !== "undefined") {
            const player = new YT.Player(id, {
              host: "http://www.youtube.com",
              videoId: $vid.data("youtube"),
              wmode: "transparent",
              playerVars: {
                autoplay: 0,
                controls: 0,
                disablekb: 1,
                enablejsapi: 1,
                fs: 0,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                wmode: "transparent",
              },
              events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange,
              },
            });
          }
        });
      }

      function onSlickImageBeforeChange() {
        const player = $slick
          .find(".slick-slide.slick-active")
          .data("youtube-player");
        player &&
          (player.stopVideo(), $slick.removeClass("slick-slider--playvideo"));
      }

      function onSlickImageAfterChange() {
        const player = $slick
          .find(".slick-slide.slick-active")
          .data("youtube-player");
        player &&
          ($slick.slick("slickPause"),
          $slick.addClass("slick-slider--playvideo"),
          player.playVideo());
      }
    },
    productSizeChart: function ($scope) {
      window.sizeChart = function () {
        var sizeChartBtn = $scope.find("[data-open-size-chart-popup]");
        sizeChartBtn.on("click", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            document.body.classList.add("size-chart-show"),
            document.body.classList.contains("quick-view-show")
              ? $(".halo-popup-content .halo-size-chart-popup").addClass(
                  "is-show"
                )
              : $("#MainContent .halo-size-chart-popup").addClass("is-show");
        }),
          $doc.on("click", "[data-close-size-chart-popup]", () => {
            $body.removeClass("size-chart-show"),
              $(".halo-size-chart-popup").removeClass("is-show");
          }),
          $doc.on("click", (event2) => {
            $body.hasClass("size-chart-show") &&
              $(event2.target).closest("[data-open-size-chart-popup]")
                .length === 0 &&
              $(event2.target).closest("[data-size-chart-popup]").length ===
                0 &&
              $body.removeClass("size-chart-show");
          });
      };
      var quickViewShow = document.body.classList.contains("quick-view-show"),
        productSizeChart = $(".halo-productView .productView-sizeChart").length;
      document.body.classList.contains("template-product")
        ? ((!quickViewShow && productSizeChart) ||
            (quickViewShow && productSizeChart === 0)) &&
          window.sizeChart()
        : window.sizeChart();
    },
    productLastSoldOut: function ($scope) {
      var wrapper = $scope.find("[data-sold-out-product]");
      if (wrapper.length > 0) {
        var numbersProductList = wrapper.data("item").toString().split(","),
          numbersProductItem = Math.floor(
            Math.random() * numbersProductList.length
          ),
          numbersHoursList = wrapper.data("hours").toString().split(","),
          numbersHoursItem = Math.floor(
            Math.random() * numbersHoursList.length
          );
        wrapper
          .find("[data-sold-out-number]")
          .text(numbersProductList[numbersProductItem]),
          wrapper
            .find("[data-sold-out-hours]")
            .text(numbersHoursList[numbersHoursItem]),
          wrapper.show();
      }
    },
    productCustomerViewing: function ($scope) {
      var wrapper = $scope.find("[data-customer-view]");
      if (wrapper.length > 0) {
        var numbersViewer = wrapper.data("customer-view"),
          numbersViewerList = JSON.parse("[" + numbersViewer + "]"),
          numbersViewerTime = wrapper.data("customer-view-time"),
          timeViewer = parseInt(numbersViewerTime) * 1e3;
        setInterval(function () {
          var numbersViewerItem = Math.floor(
            Math.random() * numbersViewerList.length
          );
          wrapper
            .find(".text")
            .text(
              window.customer_view.text.replace(
                "[number]",
                numbersViewerList[numbersViewerItem]
              )
            );
        }, timeViewer);
      }
    },
    productCountdown: function ($scope) {
      var wrapper = $scope.find("[data-countdown-id]"),
        countDown = wrapper.data("countdown"),
        countDownDate = new Date(countDown).getTime(),
        countDownText = window.countdown.text;
      if (wrapper.length > 0)
        var countdownfunction = setInterval(function () {
          var now = new Date().getTime(),
            distance = countDownDate - now;
          if (distance < 0) clearInterval(countdownfunction), wrapper.remove();
          else {
            var days = Math.floor(distance / 864e5),
              hours = Math.floor(
                (distance % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60)
              ),
              minutes = Math.floor((distance % (1e3 * 60 * 60)) / (1e3 * 60)),
              seconds = Math.floor((distance % (1e3 * 60)) / 1e3),
              strCountDown;
            wrapper.is(".style-2, .style-3")
              ? (strCountDown =
                  '<span class="text"><span>' +
                  countDownText +
                  '</span></span><span class="num">' +
                  days +
                  "<span>" +
                  window.countdown.day_2 +
                  '</span></span>                                <span class="num">' +
                  hours +
                  "<span>" +
                  window.countdown.hour_2 +
                  '</span></span>                                <span class="num">' +
                  minutes +
                  "<span>" +
                  window.countdown.min_2 +
                  '</span></span>                                <span class="num">' +
                  seconds +
                  "<span>" +
                  window.countdown.sec_2 +
                  "</span></span>")
              : (strCountDown =
                  '<span class="text"><span>' +
                  countDownText +
                  '</span></span><span class="num">' +
                  days +
                  "<span>" +
                  window.countdown.day +
                  '</span></span>                                <span class="num">' +
                  hours +
                  "<span>" +
                  window.countdown.hour +
                  '</span></span>                                <span class="num">' +
                  minutes +
                  "<span>" +
                  window.countdown.min +
                  '</span></span>                                <span class="num">' +
                  seconds +
                  "<span>" +
                  window.countdown.sec +
                  "</span></span>"),
              wrapper.html(strCountDown),
              wrapper.addClass("show");
          }
        }, 1e3);
    },
    productCustomCursor: function ($scope) {
      if ($(".cursor-wrapper").length == 0) return;
      const { Back } = window;
      (this.cursorWrapper = document.querySelector(".cursor-wrapper")),
        (this.innerCursor = document.querySelector(".custom-cursor__inner")),
        (this.outerCursor = document.querySelector(".custom-cursor__outer")),
        (this.cursorWrapperBox = this.cursorWrapper.getBoundingClientRect()),
        (this.innerCursorBox = this.innerCursor.getBoundingClientRect()),
        (this.outerCursorBox = this.outerCursor.getBoundingClientRect()),
        document.addEventListener("mousemove", (e) => {
          (this.clientX = e.clientX), (this.clientY = e.clientY);
        });
      const render = () => {
        TweenMax.set(this.cursorWrapper, { x: this.clientX, y: this.clientY }),
          requestAnimationFrame(render);
      };
      requestAnimationFrame(render),
        (this.fullCursorSize = 60),
        (this.enlargeCursorTween = TweenMax.to(this.outerCursor, 0.3, {
          width: this.fullCursorSize,
          height: this.fullCursorSize,
          ease: this.easing,
          paused: !0,
        }));
      const handleMouseEnter = () => {
          this.enlargeCursorTween.play(),
            $(".cursor-wrapper")
              .addClass("handleMouseEnter")
              .removeClass("handleMouseLeave");
        },
        handleMouseLeave = () => {
          this.enlargeCursorTween.reverse(),
            $(".cursor-wrapper")
              .addClass("handleMouseLeave")
              .removeClass("handleMouseEnter");
        };
      document.querySelectorAll(".productView-image").forEach((el) => {
        el?.querySelector(".productView-video") ||
          (el.addEventListener("mouseenter", handleMouseEnter),
          el.addEventListener("mouseleave", handleMouseLeave));
      }),
        (this.bumpCursorTween = TweenMax.to(this.outerCursor, 0.1, {
          scale: 0.7,
          paused: !0,
          onComplete: () => {
            TweenMax.to(this.outerCursor, 0.2, { scale: 1, ease: this.easing });
          },
        })),
        $(document).on("mouseover", "[data-cursor-image]", (event2) => {
          var $target = $(event2.currentTarget),
            imagesInView = new Array();
          imagesInView.push($target.attr("data-index")),
            $("#count-image").text(imagesInView[0]);
        }),
        ($.fn.isInViewport = function (excludePartials) {
          var elementTop = $(this).offset().top,
            elementBottom = elementTop + $(this).height(),
            viewportTop = $(document).scrollTop(),
            viewportBottom = viewportTop + $(window).height();
          if (excludePartials) {
            var bottomVisible =
                (elementBottom - viewportTop) / $(this).height(),
              isInView =
                elementBottom > viewportTop && elementTop < viewportBottom;
            return isInView && bottomVisible > 0.5;
          }
          return elementBottom > viewportTop && elementTop < viewportBottom;
        }),
        ($(".product-full-width").length > 0 ||
          $(".product-full-width-2").length > 0) &&
          $(window).on("resize scroll", function () {
            var imagesInView = new Array();
            $(".productView-image").each(function () {
              $(this).isInViewport(!0) &&
                (imagesInView.push($(this).attr("data-index")),
                $("#count-image").text(imagesInView[0]));
            });
          });
    },
    initWishlist: function () {
      window.wishlist.show &&
        (halo.setLocalStorageProductForWishlist(),
        $doc.on("click", "[data-wishlist]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $(event2.currentTarget).hasClass("is-in-grid") ||
              $("[data-wishlist-items-display]").removeClass("is-loaded");
          var $target = $(event2.currentTarget),
            id = $target.data("product-id"),
            handle = $target.data("wishlist-handle"),
            wishlistList = localStorage.getItem("wishlistItem")
              ? JSON.parse(localStorage.getItem("wishlistItem"))
              : [];
          if (
            ((index = wishlistList.indexOf(handle)),
            (wishlistContainer = $("[data-wishlist-container]")),
            (wishlistLayout = wishlistContainer.attr("data-wishlist-layout")),
            $target.hasClass("wishlist-added"))
          ) {
            $target
              .removeClass("wishlist-added")
              .find(".text")
              .text(window.wishlist.add),
              wishlistContainer.length > 0 &&
                $('[data-wishlist-added="wishlist-' + id + '"]').length > 0 &&
                ($('[data-wishlist-added="wishlist-' + id + '"]').remove(),
                $(`[data-wishlist][data-product-id=${id}]`)
                  .closest(".product")
                  .remove()),
              wishlistList.splice(index, 1),
              localStorage.setItem(
                "wishlistItem",
                JSON.stringify(wishlistList)
              );
            const updatePaginationEvent = new CustomEvent("updatepagination", {
              bubbles: !0,
            });
            if (
              (document.dispatchEvent(updatePaginationEvent),
              wishlistContainer.length > 0)
            )
              if (
                ((wishlistList = localStorage.getItem("wishlistItem")
                  ? JSON.parse(localStorage.getItem("wishlistItem"))
                  : []),
                wishlistList.length > 0)
              ) {
                const updateWishlistMailEvent = new Event(
                  "updatewishlistmail",
                  { bubbles: !0 }
                );
                document.dispatchEvent(updateWishlistMailEvent);
              } else
                $("[data-wishlist-container]")
                  .addClass("is-empty")
                  .html(
                    `                                    <div class="wishlist-content-empty text-center">                                        <span class="wishlist-content-text">${window.wishlist.empty}</span>                                        <div class="wishlist-content-actions">                                            <a class="button button-2 button-continue" href="${window.routes.collection_all}">                                                ${window.wishlist.continue_shopping}                                            </a>                                        </div>                                    </div>                                `
                  ),
                  $("[data-wishlist-footer]").hide();
          } else {
            if (
              ($target
                .addClass("wishlist-added")
                .find(".text")
                .text(window.wishlist.added),
              wishlistContainer.length > 0)
            ) {
              const addEvent = new CustomEvent("addwishlistitem", {
                detail: { handle },
                bubbles: !0,
              });
              document.dispatchEvent(addEvent);
            }
            wishlistList.push(handle),
              localStorage.setItem(
                "wishlistItem",
                JSON.stringify(wishlistList)
              );
            const updateWishlistMailEvent = new CustomEvent(
              "updatewishlistmail",
              { bubbles: !0 }
            );
            document.dispatchEvent(updateWishlistMailEvent);
          }
          $("[data-wishlist-count]").text(wishlistList.length),
            halo.setProductForWishlist(handle);
        }));
    },
    calculateCard06Padding() {
      if (!$body.hasClass("product-card-layout-06")) return;
      const cardAction = document.querySelector(
        ".card .card-action.card-grid__hidden"
      );
      cardAction.classList.remove("card-grid__hidden");
      const padding = cardAction.scrollHeight;
      document
        .querySelector("[data-wishlist-items-grid-display]")
        .style.setProperty("--card-06-padding", padding + "px"),
        cardAction.classList.add("card-grid__hidden");
    },
    setProductForWishlist: function (handle) {
      var wishlistList = JSON.parse(localStorage.getItem("wishlistItem")),
        item = $('[data-wishlist-handle="' + handle + '"]'),
        index2 = wishlistList?.indexOf(handle);
      index2 == null ||
        wishlistList == null ||
        (index2 >= 0
          ? item
              .addClass("wishlist-added")
              .find(".text")
              .text(window.wishlist.added)
          : item
              .removeClass("wishlist-added")
              .find(".text")
              .text(window.wishlist.add));
    },
    setLocalStorageProductForWishlist: function () {
      var wishlistList = localStorage.getItem("wishlistItem")
        ? JSON.parse(localStorage.getItem("wishlistItem"))
        : [];
      localStorage.setItem("wishlistItem", JSON.stringify(wishlistList)),
        wishlistList.length > 0 &&
          ((wishlistList = JSON.parse(localStorage.getItem("wishlistItem"))),
          wishlistList.forEach((handle) => {
            halo.setProductForWishlist(handle);
          })),
        $("[data-wishlist-count]").text(wishlistList.length);
    },
    initCountdown: function () {
      var countdownAnnouncementElm = $("[data-countdown-announcement]"),
        countdownElm = $("[data-countdown]").not("[data-countdown-id]");
      countdownAnnouncementElm.length &&
        countdownAnnouncementElm.each(function () {
          var self = $(this),
            countdownAnnouncement = self.data("countdown-value"),
            countdownAnnouncementDate = new Date(
              countdownAnnouncement
            ).getTime(),
            countdownAnnouncementFunction = setInterval(function () {
              var now = new Date().getTime(),
                distance = countdownAnnouncementDate - now;
              if (distance < 0)
                if (
                  (clearInterval(countdownAnnouncementFunction),
                  self.hasClass("hide--countdown"))
                )
                  self.remove();
                else {
                  const thisItem = self.parents(".announcement-bar__message"),
                    thisBar = self.parents("[data-announcement-bar]");
                  thisBar.is(".slick-initialized")
                    ? thisBar.slick("slickRemove", thisItem.data("slick-index"))
                    : thisItem.remove();
                }
              else {
                var days = Math.floor(distance / 864e5),
                  hours = `0${Math.floor(
                    (distance % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60)
                  )}`.slice(-2),
                  minutes = `0${Math.floor(
                    (distance % (1e3 * 60 * 60)) / (1e3 * 60)
                  )}`.slice(-2),
                  seconds = `0${Math.floor(
                    (distance % (1e3 * 60)) / 1e3
                  )}`.slice(-2),
                  strCountDown = "";
                (strCountDown =
                  '<div class="clock-item"><span class="num">' +
                  days +
                  '</span><span class="text">' +
                  window.countdown.days +
                  '</span></div>                                            <div class="clock-item"><span class="num">' +
                  hours +
                  '</span><span class="text">' +
                  window.countdown.hours +
                  '</span></div>                                            <div class="clock-item"><span class="num">' +
                  minutes +
                  '</span><span class="text">' +
                  window.countdown.mins +
                  '</span></div>                                            <div class="clock-item"><span class="num">' +
                  seconds +
                  '</span><span class="text">' +
                  window.countdown.secs +
                  "</span></div>"),
                  self.html(strCountDown);
              }
            }, 1e3);
        }),
        countdownElm.length &&
          countdownElm.each(function () {
            var self = $(this),
              countDown = self.data("countdown-value"),
              countDownDate = new Date(countDown).getTime(),
              countdownfunction = setInterval(function () {
                var now = new Date().getTime(),
                  distance = countDownDate - now;
                if (distance < 0)
                  clearInterval(countdownfunction),
                    self.hasClass("hide--countdown")
                      ? self.remove()
                      : self.parents(".shopify-section").remove();
                else {
                  var days = Math.floor(distance / 864e5),
                    hours = `0${Math.floor(
                      (distance % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60)
                    )}`.slice(-2),
                    minutes = `0${Math.floor(
                      (distance % (1e3 * 60 * 60)) / (1e3 * 60)
                    )}`.slice(-2),
                    seconds = `0${Math.floor(
                      (distance % (1e3 * 60)) / 1e3
                    )}`.slice(-2),
                    strCountDown = "";
                  self.hasClass("product-countdown-block")
                    ? $(".halo-block-header").hasClass("countdown_style_2")
                      ? (strCountDown =
                          '<div class="clock-item"><span class="num">' +
                          days +
                          window.countdown.d +
                          '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                          hours +
                          window.countdown.h +
                          '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                          minutes +
                          window.countdown.m +
                          '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                          seconds +
                          window.countdown.s +
                          '</span><span class="icon"></span></div>')
                      : (strCountDown = `<div class="clock-item"><span class="num">${days}d&nbsp;</span></div>
                                    <div class="clock-item"><span class="num">${hours}:</span></div>
                                    <div class="clock-item"><span class="num">${minutes}:</span></div>
                                    <div class="clock-item"><span class="num">${seconds}</span></div>`)
                    : (strCountDown =
                        '<div class="clock-item"><span class="num">' +
                        days +
                        '</span><span class="text">' +
                        window.countdown.days +
                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                        hours +
                        '</span><span class="text">' +
                        window.countdown.hours +
                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                        minutes +
                        '</span><span class="text">' +
                        window.countdown.mins +
                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                        seconds +
                        '</span><span class="text">' +
                        window.countdown.secs +
                        "</span></div>"),
                    self.html(strCountDown);
                }
              }, 1e3);
          });
    },
    collectionCountdown: function () {
      var countdownElm = $("[data-collection-countdown]");
      countdownElm.length &&
        countdownElm.each(function () {
          var self = $(this),
            countDownCollection = (self2) => {
              var countDown = self2.data("collection-countdown-value"),
                countDownDate = new Date(countDown).getTime(),
                countDownText = window.countdown.text,
                now = new Date().getTime(),
                distance = countDownDate - now;
              if (distance < 0)
                clearInterval(countDownCollection),
                  self2.hasClass("hide--countdown") && self2.remove();
              else {
                var days = Math.floor(distance / 864e5),
                  hours = `0${Math.floor(
                    (distance % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60)
                  )}`.slice(-2),
                  minutes = `0${Math.floor(
                    (distance % (1e3 * 60 * 60)) / (1e3 * 60)
                  )}`.slice(-2),
                  seconds = `0${Math.floor(
                    (distance % (1e3 * 60)) / 1e3
                  )}`.slice(-2),
                  strCountDown = "";
                self2.hasClass("collection-countdown") &&
                  (strCountDown =
                    '<div class="clock-item"><span class="num">' +
                    days +
                    '</span><span class="text">' +
                    window.countdown.days +
                    '</span></div>                                                <div class="clock-item"><span class="num">' +
                    hours +
                    '</span><span class="text">' +
                    window.countdown.hours +
                    '</span></div>                                                <div class="clock-item"><span class="num">' +
                    minutes +
                    '</span><span class="text">' +
                    window.countdown.mins +
                    '</span></div>                                                <div class="clock-item"><span class="num">' +
                    seconds +
                    '</span><span class="text">' +
                    window.countdown.secs +
                    "</span></div>"),
                  self2.html(strCountDown);
              }
            };
          setInterval(() => {
            countDownCollection(self);
          }, 1e3);
        });
    },
    handleScrollDown: function () {
      var iconSrollDownSlt = "[data-scroll-down]",
        iconSrollDown = $(iconSrollDownSlt);
      iconSrollDownSlt.length &&
        iconSrollDown.each(function () {
          var self = $(this),
            target = self
              .closest(".shopify-section")
              .next(".shopify-section")
              .attr("id");
          self.attr("href", "#" + target),
            iconSrollDown.on("click", function (e) {
              e.preventDefault();
              var scroll = $(this.getAttribute("href"));
              scroll.length &&
                $("html, body")
                  .stop()
                  .animate({ scrollTop: scroll.offset().top }, 400);
            });
        });
    },
    toggleSidebarMobile: function () {
      $doc.on("click", "[data-sidebar]", (event2) => {
        event2.preventDefault(),
          event2.stopPropagation(),
          $body.addClass("open-mobile-sidebar");
      }),
        $doc.on("click", "[data-close-sidebar]", (event2) => {
          event2.preventDefault(),
            event2.stopPropagation(),
            $body.removeClass("open-mobile-sidebar");
        }),
        $doc.on("click", (event2) => {
          $body.hasClass("open-mobile-sidebar") &&
            $(event2.target).closest("[data-sidebar]").length === 0 &&
            $(event2.target).closest("#halo-sidebar").length === 0 &&
            $body.removeClass("open-mobile-sidebar");
        });
    },
    initBlogMasonry: function () {
      const $blogMasonry = $(".blog-layout-masonry .blog-block-item"),
        isRTL = $body.hasClass("layout_rtl");
      $blogMasonry.masonry({
        columnWidth: ".blog-grid-sizer",
        itemSelector: "[data-masonry-item]",
        isRTL,
        originLeft: !isRTL,
      });
    },
    articleGallery: function () {
      const $gallery = $(".articleGallery-block"),
        $gallerySlider = $(".articleGallery-slider"),
        galleryLength = $gallery.length,
        col = $gallerySlider.data("col");
      galleryLength > 0 &&
        $gallerySlider.not(".slick-initialized") &&
        $gallerySlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: !0,
          arrows: !0,
          infinite: !1,
          mobileFirst: !0,
          focusOnSelect: !1,
          nextArrow: window.arrows.icon_next,
          prevArrow: window.arrows.icon_prev,
          rtl: window.rtl_slick,
          responsive: [
            {
              breakpoint: 767,
              settings: { slidesToShow: col, slidesToScroll: col },
            },
            {
              breakpoint: 319,
              settings: { slidesToShow: 2, slidesToScroll: 2 },
            },
          ],
        });
    },
    initCollapseSidebarBlock: function () {
      $doc.on(
        "click",
        ".sidebarBlock-headingWrapper .sidebarBlock-heading",
        (event2) => {
          var $target = $(event2.currentTarget),
            $blockCollapse = $target.parent().siblings(),
            $sidebarBlock = $target.parents(".sidebarBlock");
          $target.hasClass("is-clicked")
            ? ($target.removeClass("is-clicked"),
              $blockCollapse.slideUp("slow"))
            : ($target.addClass("is-clicked"),
              $blockCollapse.slideDown("slow"),
              $sidebarBlock.hasClass("sidebar-product") &&
                $sidebarBlock.find(".products-carousel").slick("refresh"));
        }
      );
    },
    initCategoryActive: function () {
      $(".all-categories-list").length > 0 &&
        ($doc.on("click", ".all-categories-list .icon-dropdown", (event2) => {
          var $target = $(event2.currentTarget).parent();
          $target.siblings().removeClass("is-clicked current-cate"),
            $target.toggleClass("is-clicked"),
            $target
              .siblings()
              .find("> .dropdown-category-list")
              .slideUp("slow"),
            $target.find("> .dropdown-category-list").slideToggle("slow");
        }),
        $(".all-categories-list li").each((index2, element) => {
          $(element).hasClass("current-cate") &&
            $(element).find("> .dropdown-category-list").slideToggle("slow");
        }));
    },
    productBlockSilderSidebar: function () {
      var productGrid = $("[data-product-slider-sidebar]"),
        itemToShow = productGrid.data("item-to-show"),
        itemDots = productGrid.data("item-dots"),
        itemArrows = productGrid.data("item-arrows");
      productGrid.length > 0 &&
        productGrid.not(".slick-initialized") &&
        productGrid.slick({
          mobileFirst: !0,
          adaptiveHeight: !0,
          vertical: !1,
          infinite: !1,
          slidesToShow: itemToShow,
          slidesToScroll: 1,
          arrows: itemArrows,
          dots: itemDots,
          autoplay: !0,
          autoplaySpeed: 2e3,
          nextArrow: window.arrows.icon_next,
          prevArrow: window.arrows.icon_prev,
          rtl: window.rtl_slick,
        });
    },
    productBlockSilderArticle: function () {
      var productGrid = $("[data-product-slider-article]"),
        itemToShow = productGrid.data("item-to-show"),
        itemDots = productGrid.data("item-dots"),
        itemArrows = productGrid.data("item-arrows");
      productGrid.length > 0 &&
        productGrid.not(".slick-initialized") &&
        productGrid.slick({
          adaptiveHeight: !0,
          vertical: !1,
          infinite: !1,
          slidesToShow: itemToShow,
          slidesToScroll: 1,
          arrows: itemArrows,
          dots: itemDots,
          nextArrow: window.arrows.icon_next,
          prevArrow: window.arrows.icon_prev,
          rtl: window.rtl_slick,
          responsive: [
            {
              breakpoint: 992,
              settings: { slidesToShow: 3, slidesToScroll: 1 },
            },
            {
              breakpoint: 551,
              settings: { slidesToShow: 2, slidesToScroll: 1 },
            },
          ],
        });
    },
    articleGallery: function () {
      const $gallery = $(".articleGallery-block"),
        $gallerySlider = $(".articleGallery-slider"),
        galleryLength = $gallery.length,
        col = $gallerySlider.data("col");
      galleryLength > 0 &&
        $gallerySlider.not(".slick-initialized") &&
        $gallerySlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: !0,
          arrows: !0,
          infinite: !1,
          mobileFirst: !0,
          focusOnSelect: !1,
          nextArrow: window.arrows.icon_next,
          prevArrow: window.arrows.icon_prev,
          rtl: window.rtl_slick,
          responsive: [
            {
              breakpoint: 767,
              settings: { slidesToShow: col, slidesToScroll: col },
            },
            {
              breakpoint: 319,
              settings: { slidesToShow: 2, slidesToScroll: 2 },
            },
          ],
        });
    },
    initInfiniteScrolling: function () {
      $(!0) &&
        $win.on("scroll load", () => {
          var currentScroll = $win.scrollTop(),
            pageInfinite = $(".pagination-infinite"),
            linkInfinite = pageInfinite.find("[data-infinite-scrolling]"),
            position;
          if (
            linkInfinite.length > 0 &&
            !linkInfinite.hasClass("is-loading") &&
            ((position = pageInfinite.offset().top - 500),
            currentScroll > position)
          ) {
            var url = linkInfinite.attr("href");
            halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
          }
        }),
        $doc.on("click", "[data-infinite-scrolling]", (event2) => {
          var linkInfinite = $(event2.currentTarget),
            url = linkInfinite.attr("href");
          event2.preventDefault(),
            event2.stopPropagation(),
            halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
        });
    },
    doAjaxInfiniteScrollingGetContent: function (url, link) {
      $.ajax({
        type: "GET",
        url,
        beforeSend: function () {
          link.text(link.attr("data-loading-more")),
            link.addClass("is-loading");
        },
        success: function (data) {
          halo.ajaxInfiniteScrollingMapData(data);
        },
        error: function (xhr, text) {
          alert($.parseJSON(xhr.responseText).description);
        },
        complete: function () {
          link.text(link.attr("data-load-more")),
            link.removeClass("is-loading"),
            document.querySelector(".collection-masonry") &&
              resizeAllGridItems();
        },
      });
    },
    ajaxInfiniteScrollingMapData: function (data) {
      var currentTemplate = $("#CollectionProductGrid"),
        currentProductListing = currentTemplate.find(".productListing"),
        currentPagination = currentTemplate.find(".pagination"),
        newTemplate = $(data).find("#CollectionProductGrid"),
        newProductListing = newTemplate.find(".productListing"),
        newPagination = newTemplate.find(".pagination"),
        newProductItem = newProductListing.children(".product");
      if (newProductItem.length > 0) {
        if (
          (currentProductListing.append(newProductItem),
          currentPagination.replaceWith(newPagination),
          $("[data-total-start]").text(1),
          window.compare.show)
        ) {
          var $compareLink = $("[data-compare-link]");
          halo.setLocalStorageProductForCompare($compareLink);
        }
        window.wishlist.show && halo.setLocalStorageProductForWishlist(),
          halo.checkNeedToConvertCurrency() &&
            Currency.convertAll(
              window.shop_currency,
              $("#currencies .active").attr("data-currency"),
              "span.money",
              "money_format"
            );
      }
    },
    initQuickShopProductList: function () {
      $doc.on("click", "[data-open-quickshop-popup-list]", (event2) => {
        event2.preventDefault(), event2.stopPropagation();
        var handle = $(event2.currentTarget).data("product-handle"),
          product = $(event2.currentTarget).closest(".card");
        product.hasClass("quick-shop-show") ||
          halo.updateContentQuickShop(product, handle);
      }),
        $doc.on("click", "[data-close-quickshop-popup-list]", (event2) => {
          event2.preventDefault(), event2.stopPropagation();
          var product = $(event2.currentTarget).closest(".card");
          product.removeClass("quick-shop-show"),
            product.find(".card-popup-content").empty();
        }),
        $doc.on("click", (event2) => {
          $(".card").hasClass("quick-shop-show") &&
            $(event2.target).closest("[data-open-quickshop-popup-list]")
              .length === 0 &&
            $(event2.target).closest(".card-popup").length === 0 &&
            ($(".card").removeClass("quick-shop-show"),
            $(".card").find(".card-popup-content").empty());
        });
    },
    updateContentQuickShop: function (product, handle) {
      var popup = product.find(".card-popup"),
        popupContent = popup.find(".card-popup-content");
      $.ajax({
        type: "get",
        url:
          window.routes.root + "/products/" + handle + "?view=ajax_quick_shop",
        beforeSend: function () {
          $(".card").removeClass("quick-shop-show");
        },
        success: function (data) {
          popupContent.append(data);
        },
        error: function (xhr, text) {
          alert($.parseJSON(xhr.responseText).description);
        },
        complete: function () {
          product.addClass("quick-shop-show");
        },
      });
    },
    toggleVariantsForExpressOrder: function () {
      var toggleVariant = "[data-toggle-variant]";
      $(document).on("click", toggleVariant, function (e) {
        e.preventDefault(), e.stopPropagation();
        var self = $(this),
          curVariants = self.data("target");
        self.hasClass("show-options-btn")
          ? (self.text(window.inventory_text.hide_options),
            $(curVariants).slideDown(700, function () {
              self.addClass("hide-options-btn").removeClass("show-options-btn");
            }))
          : (self.text(window.inventory_text.show_options),
            $(curVariants).slideUp(700, function () {
              self.addClass("show-options-btn").removeClass("hide-options-btn");
            }));
      });
    },
    initExpressOrderAddToCart: function () {
      var addToCartSlt = "[data-express-addtocart]";
      $(document)
        .off("click.addToCartExpress", addToCartSlt)
        .on("click.addToCartExpress", addToCartSlt, function (e) {
          e.preventDefault();
          var self = $(this);
          if (self.attr("disabled") != "disabled") {
            var productItem = self.closest(".product-item");
            productItem.length == 0 &&
              (productItem = self.closest(".col-options"));
            var form = productItem.find("form"),
              variant_id = form.find("select[name=id]").val();
            variant_id || (variant_id = form.find("input[name=id]").val());
            var quantityElm = productItem.find("input[name=quantity]");
            quantityElm.length == 0 &&
              (quantityElm = productItem
                .siblings(".col-qtt")
                .find("input[name=quantity]"));
            var quantity = quantityElm.val();
            quantity || (quantity = 1),
              parseInt(quantity) !== 0
                ? window.ajax_cart == "none"
                  ? form.submit()
                  : (halo.expressAjaxAddToCart(
                      variant_id,
                      quantity,
                      self,
                      form
                    ),
                    form.next(".feedback-text").show())
                : form
                    .next(".feedback-text")
                    .text("Quantity cannot be blank")
                    .show();
          }
          return !1;
        });
    },
    expressAjaxAddToCart: function (variant_id, quantity, cartBtn, form) {
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: "quantity=" + quantity + "&id=" + variant_id,
        dataType: "json",
        beforeSend: function () {
          window.setTimeout(function () {
            cartBtn.text(window.inventory_text.adding + "...");
          }, 100);
        },
        success: function (msg) {
          switch (
            (window.setTimeout(function () {
              cartBtn.text(window.inventory_text.thank_you),
                cartBtn.addClass("add_more"),
                form
                  .next(".feedback-text")
                  .text(window.inventory_text.cart_feedback)
                  .addClass("is-added");
            }, 600),
            window.setTimeout(function () {
              cartBtn.text(window.inventory_text.add_more + "...");
            }, 1e3),
            window.after_add_to_cart.type)
          ) {
            case "cart":
              halo.redirectTo(window.routes.cart);
              break;
            case "quick_cart":
              window.quick_cart.show
                ? Shopify.getCart((cart) => {
                    window.quick_cart.type == "popup" ||
                      ($body.addClass("cart-sidebar-show"),
                      halo.updateSidebarCart(cart));
                  })
                : halo.redirectTo(window.routes.cart);
              break;
            case "popup_cart_1":
              Shopify.getCart((cart) => {
                halo.updatePopupCart(cart, 1, variant_id),
                  halo.updateSidebarCart(cart),
                  $body.addClass("add-to-cart-show");
              });
              break;
          }
        },
        error: function (xhr, text) {
          alert($.parseJSON(xhr.responseText).description),
            window.setTimeout(function () {
              cartBtn.text(window.inventory_text.add_to_cart);
            }, 400);
        },
      });
    },
    initProductBundle: function () {
      var productBundle = $("[data-product-bundle]"),
        bundleList = productBundle.find("[data-bundle-slider]"),
        dots = bundleList.data("dots"),
        arrows = bundleList.data("arrows");
      bundleList.length > 0 &&
        (bundleList.hasClass("slick-initialized") ||
          (bundleList.slick({
            dots: !0,
            arrows,
            slidesToShow: 2,
            slidesToScroll: 1,
            mobileFirst: !0,
            infinite: !1,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            rtl: window.rtl_slick,
            responsive: [
              {
                breakpoint: 1200,
                settings: { slidesToShow: 4, slidesToScroll: 1, dots },
              },
              {
                breakpoint: 551,
                settings: { slidesToShow: 3, slidesToScroll: 1, dots },
              },
            ],
          }),
          productBundle
            .find(".bundle-product-wrapper")
            .removeClass("has-halo-block-loader"),
          bundleList.on("afterChange", function () {
            bundleList.find(".bundle-product-item").removeClass("is-open");
          })));
    },
    initProductReviewSection: function () {
      $doc.ready(() => {
        setTimeout(() => {
          const $reviewTabContent = $(".productView-review .spr-content"),
            $thisReviewSection = $(".shopify-app-block .spr-content");
          if ($reviewTabContent && $thisReviewSection) {
            const reviewContent = $reviewTabContent.html();
            $thisReviewSection.html(reviewContent);
          }
        }, 1e3);
      });
    },
    initDynamicBrowserTabTitle: function () {
      if (window.dynamic_browser_title.show) {
        var pageTitleContent = document.title,
          newPageTitleContent = window.dynamic_browser_title.text;
        (window.onblur = function () {
          document.title = window.dynamic_browser_title.text;
        }),
          (window.onfocus = function () {
            document.title = pageTitleContent;
          });
      }
    },
    initWarningPopup: function () {
      (this.warningPopup = document.querySelector("[data-warning-popup]")),
        (this.warningPopupContent = this.warningPopup.querySelector(
          "[data-halo-warning-content]"
        )),
        (this.warningPopupCloseButton = this.warningPopup.querySelector(
          "[data-close-warning-popup]"
        )),
        this.warningPopupCloseButton.addEventListener("click", () => {
          document.body.classList.remove("has-warning");
        }),
        (this.warningTime = 3e3),
        (this.warningTimeout = void 0),
        (window.warningTimeout = this.warningTimeout);
    },
    showWarning: function (content, time = this.warningTime) {
      this.warningTimeout && clearTimeout(this.warningTimeout),
        (this.warningPopupContent.textContent = content),
        document.body.classList.add("has-warning"),
        time &&
          (this.warningTimeout = setTimeout(() => {
            document.body.classList.remove("has-warning");
          }, time));
    },
    backgroundOverlayHoverEffect: function () {
      const backgroundOverlay = document.querySelector(".background-overlay"),
        backgroundCursorWrapper = backgroundOverlay.firstChild,
        enlargeCursor = () => {
          backgroundCursorWrapper.classList.add("enlarge-cursor");
        },
        dwindleCursor = () => {
          backgroundCursorWrapper.classList.remove("enlarge-cursor");
        },
        setCursorPosition = (clientX, clientY) => {
          requestAnimationFrame(() => {
            backgroundCursorWrapper.style.setProperty("--translate-y", clientY),
              backgroundCursorWrapper.style.setProperty(
                "--translate-x",
                clientX
              );
          });
        },
        handleMouseMove = (e) => {
          setCursorPosition(e.clientX, e.clientY);
        },
        handleMouseEnter = (e) => {
          setCursorPosition(e.clientX, e.clientY), enlargeCursor();
        },
        handleMouseLeave = (e) => {
          setCursorPosition(e.clientX, e.clientY),
            backgroundCursorWrapper.removeEventListener(
              "mousemove",
              handleMouseMove
            ),
            dwindleCursor();
        };
      backgroundOverlay.addEventListener("mouseenter", handleMouseEnter),
        backgroundOverlay.addEventListener("mouseleave", handleMouseLeave),
        backgroundOverlay.addEventListener("mousemove", handleMouseMove),
        backgroundOverlay.addEventListener("click", dwindleCursor);
    },
    backgroundOverlayHoverEffect1: function () {
      const backgroundOverlay = document.querySelector(".background-overlay1");
      if (!backgroundOverlay) return;
      const backgroundCursorWrapper = backgroundOverlay.firstChild,
        enlargeCursor = () => {
          backgroundCursorWrapper.classList.add("enlarge-cursor");
        },
        dwindleCursor = () => {
          backgroundCursorWrapper.classList.remove("enlarge-cursor");
        },
        setCursorPosition = (clientX, clientY) => {
          requestAnimationFrame(() => {
            backgroundCursorWrapper.style.setProperty("--translate-y", clientY),
              backgroundCursorWrapper.style.setProperty(
                "--translate-x",
                clientX
              );
          });
        },
        handleMouseMove = (e) => {
          setCursorPosition(e.clientX, e.clientY);
        },
        handleMouseEnter = (e) => {
          setCursorPosition(e.clientX, e.clientY), enlargeCursor();
        },
        handleMouseLeave = (e) => {
          setCursorPosition(e.clientX, e.clientY),
            backgroundCursorWrapper.removeEventListener(
              "mousemove",
              handleMouseMove
            ),
            dwindleCursor();
        };
      backgroundOverlay.addEventListener("mouseenter", handleMouseEnter),
        backgroundOverlay.addEventListener("mouseleave", handleMouseLeave),
        backgroundOverlay.addEventListener("mousemove", handleMouseMove),
        backgroundOverlay.addEventListener("click", dwindleCursor);
    },
    productBlockScroller: function (wrapper) {
      const { Back } = window,
        easingEffect = Back.easeInOut.config(1.7);
      let cursorWrapper = wrapper.get(0)?.querySelector(".products-cursor");
      if (!cursorWrapper) return;
      let innerCursor = cursorWrapper.querySelector(".products-cursor__inner"),
        imageCursor = cursorWrapper.querySelector(".products-cursor__image"),
        iconCursor = cursorWrapper.querySelector(".products-cursor__icon"),
        itemTween = wrapper
          .get(0)
          ?.querySelectorAll(
            ".halo-block-content.is-scroll, .products-load.is-scroll"
          ),
        itemNotTween = wrapper
          .get(0)
          ?.querySelectorAll(
            ".card-product__group, .card-action, .card-title, .card-swatch, .variants-popup, .card-compare, .card-quickview, .card-wishlist, .list-product-tabs"
          ),
        clientX,
        clientY,
        scrollerBox,
        cursorSide = null,
        cursorInsideSwiper = !1;
      document.addEventListener("mousemove", (event2) => {
        (clientX = event2.clientX),
          (clientY = event2.clientY),
          (docClientX = event2.clientX),
          (docClientY = event2.clientY);
      });
      const render = () => {
        TweenMax.set(cursorWrapper, { x: clientX, y: clientY }),
          requestAnimationFrame(render);
      };
      requestAnimationFrame(render);
      const wrapTween = TweenMax.to([cursorWrapper], 0.1, {
          scale: 2.5,
          opacity: 1,
          backgroundColor: "rgba(42,104,118,1)",
          ease: easingEffect,
          paused: !0,
        }),
        elementTween = TweenMax.to([imageCursor, iconCursor], 0.1, {
          opacity: 1,
          ease: easingEffect,
          paused: !0,
        }),
        handleMouseEnter = (event2) => {
          wrapTween.play(),
            elementTween.play(),
            cursorWrapper.classList.add("handleMouseEnter"),
            cursorWrapper.classList.remove("handleMouseLeave");
        },
        handleMouseLeave = (event2) => {
          wrapTween.reverse(),
            elementTween.reverse(),
            cursorWrapper.classList.add("handleMouseLeave"),
            cursorWrapper.classList.remove("handleMouseEnter");
        };
      itemTween.forEach((element) => {
        element.addEventListener("mouseenter", handleMouseEnter),
          element.addEventListener("mouseleave", handleMouseLeave);
      }),
        itemNotTween.forEach((element) => {
          element.addEventListener("mouseenter", handleMouseLeave),
            element.addEventListener("mouseleave", handleMouseEnter);
        });
    },
    productCustomInformation() {
      const $customInfo = $("[data-custom-information]"),
        $thisPopup = $("#halo-product-custom-information");
      $customInfo.on("click", (event2) => {
        const $this = $(event2.currentTarget),
          title = $this.find(".title")[0].innerText,
          thisContent = $this.find(".product-customInformation__popup").html();
        thisContent === "" ||
          thisContent == null ||
          ($thisPopup.addClass("is-show"),
          $thisPopup.find(".halo-popup-title").text(title),
          $thisPopup.find(".halo-popup-content").html(thisContent),
          $body.addClass("is-custom-information"));
      }),
        $doc.on("click", "[data-close-custom-information]", () => {
          $body.removeClass("is-custom-information"),
            $thisPopup.removeClass("is-show");
        }),
        $doc.on("click", (event2) => {
          $body.hasClass("is-custom-information") &&
            $(event2.target).closest("#halo-product-custom-information")
              .length === 0 &&
            $(event2.target).closest("[data-custom-information]").length ===
              0 &&
            $body.removeClass("is-custom-information");
        });
    },
    initLazyloadObserver(loadingImages, productGrid) {
      const setLazyLoaded = (target) => {
        target.closest(".card").classList.add("ajax-loaded");
      };
      this.lazyloadedObserver = new MutationObserver(
        (mutationList, observer) => {
          mutationList.forEach((mutation) => {
            if (mutation.type == "attributes") {
              if (!mutation.target.classList.contains("lazyloaded")) return;
              setLazyLoaded(mutation.target);
            }
          });
        }
      );
      const parentObserver = new MutationObserver((mutationlist) => {
        mutationlist.forEach((mutation) => {
          mutation.type == "childList" &&
            [...mutation.addedNodes]
              .map((node) => node.querySelector(".media--loading-effect img"))
              .forEach((image) => {
                this.lazyloadedObserver.observe(image, {
                  childList: !0,
                  attributes: !0,
                });
              });
        });
      });
      productGrid &&
        parentObserver.observe(productGrid, { subtree: !1, childList: !0 }),
        loadingImages.length > 0 &&
          loadingImages.forEach((image) => {
            image.classList.contains("lazyloaded")
              ? setLazyLoaded(image)
              : this.lazyloadedObserver.observe(image, {
                  childList: !0,
                  attributes: !0,
                });
          });
    },
    observeImageLazyloaded(images) {
      images.forEach((image) => {
        this.lazyloadedObserver.observe(image, {
          childList: !0,
          attributes: !0,
        });
      });
    },
    iconZoomClickMobile() {
      $(".productView-iconZoom").on("click", (event2) => {
        document
          .querySelector(".productView-image .productView-img-container .media")
          .click();
      });
    },
    calculateTranslateYHeight() {
      const cardActions = document.querySelectorAll(
        ".card .card-action:not(.variants-popup-form)"
      );
      let heighest = 0;
      cardActions.length &&
        (cardActions.forEach((cardAction) => {
          cardAction.classList.add("temporary-show");
          const height = cardAction.clientHeight;
          height > heighest && (heighest = height),
            cardAction.classList.remove("temporary-show");
        }),
        document.body.style.setProperty(
          "--translate-y-height",
          heighest * -1 + "px"
        ));
    },
    checkScrollLayoutForRecenlyViewed() {
      const RecentlyViewedSection = document.getElementById(
        "recently-viewed-products-list-2"
      );
      RecentlyViewedSection &&
        RecentlyViewedSection.classList.contains("products-flex") &&
        new MutationObserver((mutationList, observer) => {
          const mutationRecentlyViewed = mutationList[0];
          mutationRecentlyViewed.type == "attributes" &&
            mutationRecentlyViewed.target.classList.contains(
              "recently-viewed-loaded"
            ) &&
            ($(
              mutationRecentlyViewed.target.closest(
                "[data-recently-viewed-block]"
              )
            )
              .find("[data-enable-hover]")
              .attr("data-enable-hover") === "true" &&
              RecentlyViewedSection.clientWidth <
                RecentlyViewedSection.scrollWidth &&
              halo.productBlockScroller(
                $(
                  mutationRecentlyViewed.target.closest(
                    "[data-recently-viewed-block]"
                  )
                )
              ),
            observer.disconnect());
        }).observe(RecentlyViewedSection, { attributes: !0 });
    },
    clickIconScrollSection() {
      if (!document.querySelector(".arrow-icon-scroll")) return;
      let isScrollingDown = "next";
      const sections = document.querySelectorAll(
          ".wrapper-body .shopify-section"
        ),
        sectionsLength = sections.length,
        sectionFirstHeight = sections[0]?.getBoundingClientRect().height || 0,
        sectionEndHeight =
          sections[sectionsLength - 1]?.getBoundingClientRect().height || 0,
        footerHeight =
          document
            .querySelectorAll(".shopify-section-group-footer-group")[0]
            ?.getBoundingClientRect().height || 0;
      window.pageYOffset + sectionEndHeight >=
        document.documentElement.scrollHeight - footerHeight &&
        loadRotateArrow("prev"),
        $(window).scroll(function () {
          window.pageYOffset + sectionEndHeight >=
          document.documentElement.scrollHeight - footerHeight
            ? loadRotateArrow("prev")
            : window.pageYOffset <= sectionFirstHeight / 2 &&
              loadRotateArrow("next");
        }),
        $doc.on("click", ".arrow-icon-scroll", (event2) => {
          let checkScroll = !0;
          const headerHeight =
              window.innerWidth > 1024
                ? document
                    .querySelectorAll("sticky-header")[0]
                    ?.getBoundingClientRect().height
                : document
                    .querySelector("sticky-header-mobile")
                    ?.getBoundingClientRect().height || 0,
            footerTop =
              document
                .querySelectorAll(".shopify-section-group-footer-group")[0]
                ?.getBoundingClientRect().top || -1;
          sections.forEach((element, index2) => {
            if (!checkScroll) return;
            element.getBoundingClientRect().top >= 0
              ? ((checkScroll = !1),
                isScrollingDown == "next"
                  ? (element.nextElementSibling != null &&
                      scrollToSection(
                        element.nextElementSibling.offsetTop - headerHeight
                      ),
                    sectionsLength == index2 + 2 ||
                    element.nextElementSibling == null
                      ? loadRotateArrow("prev")
                      : loadRotateArrow("next"))
                  : (element.previousElementSibling != null &&
                      scrollToSection(
                        element.previousElementSibling.offsetTop - headerHeight
                      ),
                    index2 == 1 || element.previousElementSibling == null
                      ? loadRotateArrow("next")
                      : loadRotateArrow("prev")))
              : footerTop >= 0 &&
                scrollToSection(
                  sections[sectionsLength - 1].offsetTop - headerHeight
                );
          });
        });
      function scrollToSection(scope, rotate) {
        window.scrollTo({ top: scope, behavior: "smooth" });
      }
      function loadRotateArrow(rotate) {
        (isScrollingDown = rotate),
          rotate == "next"
            ? document
                .querySelector(".arrow-icon-scroll")
                .classList.remove("rotate")
            : document
                .querySelector(".arrow-icon-scroll")
                .classList.add("rotate");
      }
    },
    specialBanner() {
      const banners = document.querySelectorAll("[sticky-special-banner]"),
        wdWidth = window.innerWidth,
        wdHeight = window.innerHeight,
        headerHeight =
          wdWidth > 1024
            ? document
                .querySelectorAll("sticky-header")[0]
                ?.getBoundingClientRect().height
            : document
                .querySelector("sticky-header-mobile")
                ?.getBoundingClientRect().height || 0;
      banners &&
        banners.forEach((element) => {
          const banner = element.querySelector(".special-banner__img_box"),
            bannerWrap = element.querySelector(".special-banner__img"),
            wrapperHeight = element
              .closest(".special-banner__wrapper")
              .getBoundingClientRect().height,
            bannerHeight = bannerWrap.getBoundingClientRect().height;
          let top = headerHeight || 0;
          wdWidth >= 1200
            ? wrapperHeight > bannerHeight &&
              (wdHeight > bannerHeight && (top = (wdHeight - bannerHeight) / 2),
              calculateSticky(banner, top))
            : wdWidth >= 768 && wdWidth < 1200
            ? wrapperHeight > bannerHeight && calculateSticky(banner, top)
            : (element.classList.remove("is-sticky"), (element.style.top = ""));
        });
      function calculateSticky(banner, top) {
        banner.classList.add("is-sticky"), (banner.style.top = `${top}px`);
      }
    },
    specialBannerSlider() {
      const productGrid = $(".special-banner__products--grid"),
        wdWidth = window.innerWidth;
      productGrid &&
        productGrid.each(function (index2, element) {
          const $this = $(element),
            $block = $this.closest(".special-banner__product");
          $block.hasClass("ajax-loaded") &&
            (wdWidth < 1200
              ? $this.hasClass("slick-initialized") ||
                ($this.addClass("products-carousel"),
                specialProductSlider($block))
              : $this.hasClass("slick-initialized") &&
                ($this.slick("unslick"),
                $this.removeClass("products-carousel")));
        });
      function specialProductSlider(wrapper) {
        let productGrid2 = wrapper.find(".products-carousel"),
          itemToShow = productGrid2.data("item-to-show"),
          itemDots = productGrid2.data("item-dots"),
          itemDotsMb = productGrid2.data("item-dots-mb"),
          itemArrows = productGrid2.data("item-arrows"),
          itemArrowsMb = productGrid2.data("item-arrows-mb");
        productGrid2.slick({
          mobileFirst: !0,
          adaptiveHeight: !0,
          infinite: !0,
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: itemArrowsMb,
          dots: itemDotsMb,
          nextArrow: window.arrows.icon_next,
          prevArrow: window.arrows.icon_prev,
          rtl: window.rtl_slick,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: itemArrows,
                dots: itemDots,
                slidesToShow: itemToShow,
                slidesToScroll: itemToShow,
              },
            },
          ],
        });
      }
    },
  };
})(jQuery);
//# sourceMappingURL=/s/files/1/0773/6481/t/32/assets/theme.js.map?v=1714045566
